import {
  CommonHelperFunctions,
  DashboardState,
  EActionCategory,
  ECardinality,
  EDatasourceType,
  ESdChangeReason,
  ESymbolCategory,
  EUserAccessPart,
  IAction,
  IActionDefinitionDto,
  IActionParameter,
  IConditionModel,
  IDisplayItem,
  IIfThenElseDataModel,
  IImportMappedExcelColumnMap,
  IProcessStepScreensInfo,
  IScreenDesign,
  ISymbol,
  ITargetScreenInputParam,
  IWorkFlow,
  IWorkFlowDto
} from "@kuika/kuika-cl-model";
import {
  IForEachDataModel,
  IKType,
  IManagedDbDataModel,
  IMqttActionsDataModel,
  IMultiReportPrintData,
  IRecurringActionsDataModel
} from "@kuika/kuika-cl-model/src/models/builder.dtos";
import { EWFAssignmentType, IUserInteraction, IWFParameter } from "@kuika/kuika-cl-model/src/models/workflow";
import { CascaderOptionType } from "antd/es/cascader";
import classNames from "classnames";
import { Guid } from "guid-typescript";
import _ from "lodash";
import React from "react";
import type { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import isEqual from "react-fast-compare";
import localStorageService from "../../../../auth/local-storage-service";
import { IActionClipboard } from "../../../../models/interface/action-clipboard";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IPureDesignComponentProps, IPureDesignComponentState, PureSdComponent } from "../../../../shared/pure-sd";
import { getActionDocUrl } from "../../../../shared/utility/action-doc";
import {
  formatQualifiedName,
  getActionDatasourceQualifier
} from "../../../../shared/utility/datasource-name-qualifier";
import {
  addDesignerActionBlankCondition,
  addDesignerActionConfirmation,
  addDesignerActionRecurring,
  ensureDesignerActionParameters,
  removeDesignerActionCondition,
  removeDesignerActionConfirmation,
  removeDesignerActionRecurring,
  setDesignerActionAddGoBackAction,
  setDesignerActionAuditEnabled,
  setDesignerActionAuditLevel,
  setDesignerActionEnabled,
  setDesignerActionCondition,
  setDesignerActionConfirmation,
  setDesignerActionDescriptionWithParameter,
  setDesignerActionDontTriggerValidations,
  setDesignerActionForEachData,
  setDesignerActionIfThenElseCondition,
  setDesignerActionManagedDbData,
  setDesignerActionMqttSubscribeData,
  setDesignerActionMultiReportData,
  setDesignerActionParameter,
  setDesignerActionRecurringActionsData,
  setDesignerActionRecurringInterval,
  setDesignerActionNote,
  setDesignerActionSqlLikeSetting,
  setDesignerActionTag,
  setDesignerActionValues
} from "../../../../shared/utility/designer-action-actions";
import {
  buildDesignerActionClipboard,
  pasteDesignerActionClipboard
} from "../../../../shared/utility/designer-action-clipboard-actions";
import { getDesignerActionParameterEditorConfig } from "../../../../shared/utility/designer-action-parameter-editor-actions";
import {
  createDesignerCommonConfig,
  deleteDesignerCommonConfig,
  updateDesignerCommonConfig
} from "../../../../shared/utility/designer-common-config-actions";
import { getSdInstance } from "../../../../shared/utility/designer-context";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { SaveStatus } from "../../../../shared/utility/save-status";
import { ScreenDesignHelper } from "../../../../shared/utility/screen-design-helper";
import {
  buildSqlActionQueryWithParameters,
  canCopySqlActionQuery,
  ISqlActionQueryCopyResult
} from "../../../../shared/utility/sql-action-query-copy";
import { KModal } from "../../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../../ui-kit/k-modal/k-modal-footer";
import KuikaBadge from "../../../ui-kit/kuika-badge/kuika-badge";
import KuikaButton, { type KuikaButtonStatus } from "../../../ui-kit/kuika-button/kuika-button";
import KuikaCollapsePanel from "../../../ui-kit/kuika-collapse-panel/kuika-collapse-panel";
import { copyTextToClipboard } from "../../../ui-kit/kuika-copy-button/copy-text-to-clipboard";
import KuikaDropdownMenu from "../../../ui-kit/kuika-dropdown-menu/kuika-dropdown-menu";
import KuikaInfoBox from "../../../ui-kit/kuika-info-box/kuika-info-box";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaModalIconWrapper, {
  type KuikaModalIconIntent
} from "../../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaOverflowText from "../../../ui-kit/kuika-overflow-text/kuika-overflow-text";
import { OVERFLOW_REVEAL_HOST_CLASS } from "../../../ui-kit/kuika-overflow-text/overflow-reveal-controller";
import KuikaPopover from "../../../ui-kit/kuika-popover/kuika-popover";
import KuikaSelectbox from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaSwitch from "../../../ui-kit/kuika-switch/kuika-switch";
import KuikaTabs from "../../../ui-kit/kuika-tabs/kuika-tabs";
import { KuikaTag } from "../../../ui-kit/kuika-tag/kuika-tag";
import { toast } from "../../../ui-kit/kuika-toast";
import KuikaH5 from "../../../ui-kit/typography/H5/H5";
import KuikaSmallMediumText from "../../../ui-kit/typography/SmallMediumText/SmallMediumText";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import KuikaText from "../../../ui-kit/typography/Text/Text";
import KuikaTextMedium from "../../../ui-kit/typography/TextMedium/TextMedium";
import {
  ICommonConfigDeleteFunctionParams,
  ICommonConfigSaveFunctionParams
} from "../../app-settings/app-settings-config-manager/app-settings-config-container";
import { ConfigApifySettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-apify";
import { ConfigBraveSearchSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-brave-search";
import { ConfigDropboxSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-dropbox";
import { ConfigFirecrawlMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-firecrawl";
import { ConfigGithubSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-github";
import { ConfigGoogleMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-google-mcp";
import { ConfigGoogleMapMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-google-mcp-map";
import { ConfigJiraMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-jira";
import { ConfigOffice365McpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-ofice-365-mcp";
import { ConfigSlackSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-slack";
import { ConfigTrelloMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-trello";
import { ConfigYoutubeMcpSettings } from "../../app-settings/app-settings-config-manager/app-settings-config-mcp/app-settings-config-youtube";
import { ActionCondition } from "./action-condition";
import { ActionConfirmation } from "./action-confirmation";
import {
  EActionPanelSurface,
  IMPORT_MAPPED_EXCEL_STANDARD_PARAMETERS,
  isFooterToggleParameter,
  isOptionalParameterMenuOffered,
  resolveActionPanelSurface
} from "./action-parameter-surface";
import { isActionParameterShownInPanel } from "./action-parameter-visibility";
import { ActionSymbolWithChild } from "./action-symbol-with-child";
import { AddToBagSymbolsGroup } from "./add-to-bag-symbols-group";
import { BagHasKeySymbolsGroup } from "./bag-has-key-symbols-group";
// BulkDmsSymbolsGroup removed — bulk actions simplified to folderId + action-specific params
import { CacheHasKeySymbolsGroup } from "./cache-has-key-symbols-group";
import { ClearDynamicFormSymbolsGroup } from "./clear-dynamic-form-symbols-group";
import { ComponentToPdfSymbolGroup } from "./component-to-pdf-symbols-group";
import { ConfirmationSymbolGroup } from "./confirmation-symbol-group";
import { DocumentParametersSymbolsGroup } from "./document-parameters-symbols-group";
import { FetchFromCacheSymbolsGroup } from "./fetch-from-cache-symbols-group";
import { focusFirstEditableControl } from "./focus-first-property-control";
import { ForEachActionSymbolGroup } from "./for-each-action-symbol-group";
import { GetEntityAttributeValueInDynamicFormSymbolsGroup } from "./get-entity-attribute-value-in-dynamic-form-symbols-group";
import { GetEntityValueFromDynamicFormSymbolsGroup } from "./get-entity-value-from-dynamic-form-symbols-group";
import { GetFromBagSymbolsGroup } from "./get-from-bag-symbols-group";
import { GetIsDynamicFormValidSymbolsGroup } from "./get-is-dynamic-form-valid-symbols-group";
import { IfThenElseConditionSymbolGroup } from "./if-then-else-condition-symbol-group";
import { IfThenElseSymbolGroup } from "./if-then-else-symbol-group";
import { ImportMappedExcelSymbolsGroup } from "./import-mapped-excel-symbols-group";
import { ManagedDbDeleteSymbolGroup } from "./managed-db-delete-symbol-group";
import { ManagedDbSaveSymbolGroup } from "./managed-db-save-symbol-group";
import { MqttSubscribeActionsSymbolGroup } from "./mqtt-subscribe-actions-symbol-group";
import { MultiReportPrintSymbolsGroup } from "./multi-report-print-symbols-group";
import { NavigationSymbolsGroup } from "./navigation-symbols-group";
import { NodeTreeExportSymbolsGroup } from "./node-tree-export-symbols-group";
import { NotifySymbolsGroup } from "./notify-symbols-group";
import { OpenInBrowserSymbolsGroup } from "./open-in-browser-symbols-group";
import { OpenPdfSymbolsGroup } from "./open-pdf-symbols-group";
import { OptionalParameterList } from "./optional-parameter-list";
import { PrintReportSymbolsGroup } from "./print-report-symbols-group";
import { IPropertyFormSelectPropertyOption } from "./property-form-select-property";
import { PushToCacheSymbolsGroup } from "./push-to-cache-symbols-group";
import { RecurringActionInput } from "./recurring-action-input";
import { RecurringActionsSymbolGroup } from "./recurring-actions-symbol-group";
import { RemoveFromBagSymbolsGroup } from "./remove-from-bag-symbols-group";
import { RemoveFromCacheSymbolsGroup } from "./remove-from-cache-symbols-group";
import { SaveActionResultSymbolsGroup } from "./save-action-result-symbols-group";
import { SaveSourceSymbolsGroup } from "./save-source-symbols-group";
import { SearchSymbolsGroup } from "./search-symbols-group";
import { SelectElementIdSymbolGroup } from "./select-element-id-symbols-group";
import { SendMailWithTemplateSymbolsGroup } from "./send-mail-with-template-symbols-group";
import { SendPushNotificationSymbolsGroup } from "./send-push-notification-symbols-group";
import { SendWhatsappBusinessMessageSymbolsGroup } from "./send-whatsapp-business-message-symbols-group";
import { SetCollapsePanelSymbolsGroup } from "./set-collapse-panel-symbols-group";
import { SetEnabledSymbolsGroup } from "./set-enabled-symbols-group";
import { SetEntityAttributeValueInDynamicFormSymbolsGroup } from "./set-entity-attribute-value-in-dynamic-form-symbols-group";
import { SetToogleEnableVisibleSymbolsGroup } from "./set-toogle-enable-visible-symbols-group";
import { SetValueSymbolsGroup } from "./set-value-symbols-group";
import { SetVisibleSymbolsGroup } from "./set-visible-symbols-group";
import { StripeChargeSetupIntentSymbolsGroup } from "./stripe-charge-payment-intent-symbols-group";
import { StripePaymentIntentSymbolsGroup } from "./stripe-payment-intent-symbols-group";
import { StripeSetupIntentSymbolsGroup } from "./stripe-setup-intent-symbols-group";
import { TableConfigSymbolsGroup } from "./table-config-symbols-group";
import { PhotoTakeymbolsGroup } from "./take-photo-symbols-group";
import { ToggleLayoutSymbolsGroup } from "./toggle-layout-symbols-group";
import { TriggerEventSymbolsGroup } from "./trigger-event-symbols-group";
import { UpdateUserStartingScreenSymbolsGroup } from "./update-user-starting-screen-symbols-group";
import { WFExternalStartSymbolsGroup } from "./workflow-external-start-symbols-group";
import { WFGenericProcessesSymbolsGroup } from "./workflow-generic-processes-symbols-group";
import { WFGenericTasksSymbolsGroup } from "./workflow-generic-tasks-symbols-group";
import { WFMigrateProcessSymbolsGroup } from "./workflow-migrate-process-symbols-group";
import { WFResumeSymbolsGroup } from "./workflow-resume-symbols-group";
import { WFStartSymbolsGroup } from "./workflow-start-symbols-group";
import "./action-card.scss";

export interface ISelectboxInputOption {
  label: string;
  value: string | number;
  isDefault?: boolean;
}

export type SelectboxInputParameter = SelectboxInputParameterStatic | SelectboxInputParameterDynamic;

export interface SelectboxInputParameterStatic {
  name: string;
  options: ISelectboxInputOption[];
  isDynamic?: false;
  isMultiSelect?: boolean;
  hideFixedValue?: boolean;
  hideWFParams?: boolean;
  hideCategoryChange?: boolean;
  hideActionResults?: boolean;
  dropdownHeader?: React.ReactNode;
  onDropdownHeaderClick?: () => void;
  optionRenderer?: (option: IPropertyFormSelectPropertyOption, index) => React.ReactNode;
  isLoading?: boolean;
  selectClassName?: string;
}

export interface SelectboxInputParameterDynamic {
  name: string;
  options: (actionDefinition: IActionDefinitionDto) => ISelectboxInputOption[];
  isDynamic: true;
  isMultiSelect?: boolean;
  hideFixedValue?: boolean;
  hideWFParams?: boolean;
  hideCategoryChange?: boolean;
  hideActionResults?: boolean;
  selectClassName?: string;
}

export interface IActionPanelState {
  confirmationVisible: boolean;
  recurringVisible: boolean;
  uniqueKey: Guid;
  visibleActionMenu: boolean;
  mcpConfigModalVisibility: { [key: string]: { editingId?: string; visibility?: boolean } };
  noteModalVisible: boolean;
  notePopoverVisible: boolean;
  /** Where the note dialog's SAVE stands. Owned by `SaveStatus`, never set directly. */
  noteSaveStatus: KuikaButtonStatus;
}

export interface IActionPanelStatesCanBeUpdatedFromChild {
  actionParameters?: IActionParameter[];
  targetScreenInputParams?: ITargetScreenInputParam[];
  ifThenElseData?: IIfThenElseDataModel;
  recurringActionsData?: IRecurringActionsDataModel;
  actionReturnTypes?: IKType;
}

export interface IActionPanelProps {
  action: IAction;
  actionDefinition?: IActionDefinitionDto;
  actionPanelStatus: EActionPanelStatus;
  onActionSaved: (action: IAction, changeReason?: ESdChangeReason) => void;
  eventName?: string;
  deleteAction: (action: IAction) => void;
  getActionDefinitionItems: () => CascaderOptionType[];
  provided?: any;
  clipboardValue?: string | undefined;
  setClipboardValue?: (value: string) => void;
  isDragging?: boolean;
  preventActionRemoval?: boolean;
  preventActionPaste?: boolean;
  moveActionUp?: () => void;
  moveActionDown?: () => void;
}

export enum EActionPanelStatus {
  new = 1,
  edit = 2
}

/**
 * The label/switch rows at the foot of the panel. `flex-start` keeps the pair at the top of the row
 * box, where the floats this replaced used to sit, and the label is the only part allowed to shrink
 * so a long one is revealed on hover instead of being cut at a fixed width.
 */
const SWITCH_PROPERTY_ROW_STYLE: React.CSSProperties = {
  height: 52,
  paddingTop: 20,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "var(--gap-s)"
};

const SWITCH_PROPERTY_LABEL_STYLE: React.CSSProperties = { display: "block", minWidth: 0 };

class ActionPanel extends PureSdComponent<IActionPanelProps & IWithSDProps & IWithContextProp, IActionPanelState> {
  private tagInputRef = React.createRef<HTMLInputElement>();
  private noteInputRef = React.createRef<HTMLTextAreaElement>();

  private readonly noteSaveStatus: SaveStatus = new SaveStatus((noteSaveStatus: KuikaButtonStatus): void => {
    this.setState({ noteSaveStatus });
  });

  constructor(props: IActionPanelProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.state = {
      confirmationVisible: false,
      recurringVisible: false,
      uniqueKey: Guid.create(),
      visibleActionMenu: false,
      mcpConfigModalVisibility: {},
      noteModalVisible: false,
      notePopoverVisible: false,
      noteSaveStatus: "idle"
    };
  }

  get isExpandedPanel(): boolean {
    const actionId = this.props.action.id;
    const result = localStorageService.getExpandedPanelItem(actionId);
    return result === true;
  }

  set isExpandedPanel(value: boolean) {
    const actionId = this.props.action.id;
    localStorageService.setExpandedPanelItem(actionId, value);
    if (value === true) {
      setTimeout(() => {
        const el = document.querySelector(`[data-rbd-drag-handle-draggable-id="draggable_${actionId}"]`);
        this.setFocusToFirstInput(el);
      }, 100);
    }
  }

  componentDidMount(): void {
    if (
      this.props.action.tag !== null &&
      this.props.action.tag !== undefined &&
      this.props.actionDefinition?.isTagDisabled
    ) {
      this.updateActionTag(null);
    }
  }

  componentWillUnmount(): void {
    this.noteSaveStatus.dispose();
  }

  componentDidUpdate(
    prevProps: Readonly<IPureDesignComponentProps & IWithSDProps & IActionPanelProps & IWithContextProp>,
    prevState: Readonly<IPureDesignComponentState & IActionPanelState>,
    snapshot?: any
  ): void {
    // No need to look up action definition as it's passed as prop
  }

  setFocusToFirstInput = (el: any) => {
    if (!el) return;
    if (this.props.sd.dashboardState === DashboardState.reportDesigner) {
      return;
    }
    focusFirstEditableControl(el);
  };

  setFocusToConfirmationInput = (el: any) => {
    if (el) {
      if (this.props.sd.dashboardState === DashboardState.reportDesigner) {
        return;
      }
      const inputs = el.getElementsByClassName("kuika_confirmation_property");
      if (inputs?.length > 0) {
        inputs[0].focus();
        inputs[0].scrollIntoView();
      }
    }
  };

  setFocusToRecurringInput = (el: any) => {
    if (el) {
      if (this.props.sd.dashboardState === DashboardState.reportDesigner) {
        return;
      }
      const inputs = el.getElementsByClassName("kuika_recurring_property");
      if (inputs?.length > 0) {
        inputs[0].focus();
        inputs[0].scrollIntoView();
      }
    }
  };

  setFocusToCondition = (el: any) => {
    if (el) {
      const conditionLabel = el.getElementsByClassName("kuika_condition-label");
      if (conditionLabel?.length > 0) {
        conditionLabel[0].scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }
  };

  beforeOnChange = (action: IAction) => {
    const normalizedAction = ensureDesignerActionParameters(action);
    action.parameters = normalizedAction.parameters;
  };

  triggerOnActionSaved = (action: IAction, changeReason?: ESdChangeReason) => {
    const actionClone = _.cloneDeep(action);

    this.beforeOnChange(actionClone);
    if (this.props.onActionSaved) {
      this.props.onActionSaved(actionClone, changeReason);
    }
  };

  updateActionParametersForce = (actionParameters: IActionParameter[], changeReason?: ESdChangeReason) => {
    const result = setDesignerActionValues(
      { ...this.props.action, parameters: [] } as IAction,
      { actionParameters },
      changeReason
    );
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateActionParameter = (parameter: IActionParameter, symbol: ISymbol, changeReason?: ESdChangeReason) => {
    const action = setDesignerActionParameter(this.props.action, parameter, symbol);
    this.triggerOnActionSaved(action, changeReason);
  };

  updateMqttSubscribeActionsData = (
    mqttSubscribeActionsData: IMqttActionsDataModel,
    changeReason?: ESdChangeReason
  ) => {
    const result = setDesignerActionMqttSubscribeData(this.props.action, mqttSubscribeActionsData, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateIfThenElseDataCondition = (condition: IConditionModel, changeReason?: ESdChangeReason | undefined) => {
    const result = setDesignerActionIfThenElseCondition(this.props.action, condition, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateIfThenElseData = (ifThenElseData: IIfThenElseDataModel, changeReason?: ESdChangeReason) => {
    const action = _.cloneDeep(this.props.action);
    action.ifThenElseData = ifThenElseData;
    this.triggerOnActionSaved(action, changeReason);
  };

  updateForEachData = (forEachData: IForEachDataModel, changeReason?: ESdChangeReason) => {
    const result = setDesignerActionForEachData(this.props.action, forEachData, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateMultiReportData = (multiReportData: IMultiReportPrintData, changeReason?: ESdChangeReason) => {
    const result = setDesignerActionMultiReportData(this.props.action, multiReportData, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateRecurringActionsData = (recurringActionsData: IRecurringActionsDataModel, changeReason?: ESdChangeReason) => {
    const result = setDesignerActionRecurringActionsData(this.props.action, recurringActionsData, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateManagedDbData = (managedDbData: IManagedDbDataModel, changeReason?: ESdChangeReason) => {
    const result = setDesignerActionManagedDbData(this.props.action, managedDbData, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateConfirmation = (
    confirmationMessage: string | undefined,
    fontFamily: string | undefined,
    confirmationHeader: string | undefined,
    confirmationIcon: string | undefined,
    confirmationIconBackgroundColor: string | undefined,
    confirmationConfirmButtonColor: string | undefined,
    confirmationCancelButtonColor: string | undefined
  ) => {
    const result = setDesignerActionConfirmation(
      this.props.action,
      confirmationMessage,
      fontFamily,
      confirmationHeader,
      confirmationIcon,
      confirmationIconBackgroundColor,
      confirmationConfirmButtonColor,
      confirmationCancelButtonColor
    );
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateRecurringInterval = (recurringSec: number | undefined | null) => {
    const result = setDesignerActionRecurringInterval(this.props.action, recurringSec);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateCondition = (condition: IConditionModel | undefined, changeReason?: ESdChangeReason | undefined) => {
    const result = setDesignerActionCondition(this.props.action, condition, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  updateDontTriggerValidations = (dontTriggerValidations: boolean) => {
    const action = setDesignerActionDontTriggerValidations(this.props.action, dontTriggerValidations);
    this.triggerOnActionSaved(action);
  };

  updateAddGoBackAction = (addGoBackAction: boolean) => {
    const action = setDesignerActionAddGoBackAction(this.props.action, addGoBackAction);
    this.triggerOnActionSaved(action);
  };

  updateActionIsExpandedPanel = (isExpandedPanel: boolean, callback?: any) => {
    this.isExpandedPanel = isExpandedPanel;
    this.forceUpdate(callback);
  };

  updateActionDescriptionWithParameters = (description: string, parameter: IActionParameter, symbol: ISymbol) => {
    const action = setDesignerActionDescriptionWithParameter(this.props.action, description, parameter, symbol);
    this.triggerOnActionSaved(action, ESdChangeReason.DiActionUpdated);
  };

  updateValues = (values: IActionPanelStatesCanBeUpdatedFromChild, changeReason?: ESdChangeReason) => {
    const stateObj = {} as IActionPanelState;
    this.setState(stateObj);
    const result = setDesignerActionValues(this.props.action, values, changeReason);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  createCommonConfig = ({
    formInputName,
    customizedId,
    configKey,
    config,
    onSuccess,
    onError = () => {},
    onFinal
  }: ICommonConfigSaveFunctionParams) => {
    createDesignerCommonConfig(getSdInstance(), { configKey, config })
      .then(() => {
        onSuccess();
        const parameter = _.cloneDeep(this.props.action.parameters.find((x) => x.name === "settings"));

        if (!parameter) return;

        this.updateActionParameter(parameter, {
          isFixed: true,
          fixedValue: config.id,
          category: ESymbolCategory.fixed
        } as ISymbol);
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  updateCommonConfig = ({
    formInputName,
    customizedId,
    configKey,
    config,
    onSuccess,
    onError = () => {},
    onFinal
  }: ICommonConfigSaveFunctionParams) => {
    updateDesignerCommonConfig(getSdInstance(), { configKey, config })
      .then(() => {
        onSuccess();
        const parameter = _.cloneDeep(this.props.action.parameters.find((x) => x.name === "settings"));

        if (!parameter) return;

        this.updateActionParameter(parameter, {
          isFixed: true,
          fixedValue: "",
          category: ESymbolCategory.fixed
        } as ISymbol);
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  deleteCommonConfig = ({
    formInputName,
    configKey,
    configId,
    onSuccess,
    onError = () => {},
    shouldControlOtherSections,
    onFinal
  }: ICommonConfigDeleteFunctionParams) => {
    const activeConfigID = this.props.sd.activeConfiguration?.id;

    const isSettingUsedOnElswhere = this.props.sd.configurations.find(
      (config) =>
        config.id !== activeConfigID &&
        ((config.androidConfig && config.androidConfig[formInputName[1]] === configId) ||
          (config.iosConfig && config.iosConfig[formInputName[1]] === configId) ||
          (config.webConfig && config.webConfig[formInputName[1]] === configId))
    );

    if (isSettingUsedOnElswhere) {
      KMainFunctions.displayWarningNotification(
        "This setting is used on another configuration(s). Please discard this setting on other configurations before delete."
      );
      onFinal();
      return;
    }

    if (shouldControlOtherSections) {
      shouldControlOtherSections.onCannotDelete();
      onFinal();
      return;
    }

    deleteDesignerCommonConfig(getSdInstance(), { configKey, configId })
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        KMainFunctions.exceptionHandler(error);
        onError();
      })
      .finally(() => {
        onFinal();
      });
  };

  updateMcpModalVisibility = (key: string, visibility: boolean, id?: string) => {
    const mcpConfigModalVisibility = _.cloneDeep(this.state.mcpConfigModalVisibility);
    if (!mcpConfigModalVisibility[key]) {
      mcpConfigModalVisibility[key] = {};
    }
    mcpConfigModalVisibility[key].editingId = id;
    mcpConfigModalVisibility[key].visibility = visibility;
    this.setState({ mcpConfigModalVisibility });
  };

  getSelectboxParameter = (actionDefinition: IActionDefinitionDto, parameter: IActionParameter) => {
    // `sd.sdId` — the screen the CONTEXT says this panel is editing. On the canvas that is the
    // open screen (so the call is unchanged); hosted over a task screen it is that screen, and the
    // parameter's option list is built from ITS bindables (KOA-18431).
    const sharedConfig = getDesignerActionParameterEditorConfig(
      getSdInstance(),
      this.props.action,
      actionDefinition,
      parameter,
      this.props.sd.sdId
    );

    if (!sharedConfig) {
      return undefined;
    }

    let returnValue: SelectboxInputParameter = {
      name: sharedConfig.name,
      options: sharedConfig.options,
      isMultiSelect: sharedConfig.isMultiSelect,
      hideFixedValue: sharedConfig.hideFixedValue,
      hideWFParams: sharedConfig.hideWFParams,
      hideCategoryChange: sharedConfig.hideCategoryChange,
      hideActionResults: sharedConfig.hideActionResults,
      isLoading: sharedConfig.isLoading,
      selectClassName: sharedConfig.selectClassName
    };

    if (sharedConfig.settingsGroupName) {
      returnValue = {
        ...returnValue,
        optionRenderer: (o: IPropertyFormSelectPropertyOption) => {
          const isOptionSelected =
            o.value === this.props.action.parameters.find((p) => p.name === "settings")?.symbol.fixedValue;
          return (
            <div
              className="kuika_select_property__mcp-option"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "0 16px 0 0",
                textTransform: "none"
              }}
            >
              <KuikaSvg
                className="kuika_select_property__mcp-check-icon"
                name="check"
                color="var(--blue-5)"
                width={16}
                height={16}
                style={{ visibility: isOptionSelected ? "visible" : "hidden", marginRight: 8 }}
              />
              <KuikaText>{o.label}</KuikaText>
              <KuikaSvg
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (this.props.sd.isConfigListLoading) return;
                  this.updateMcpModalVisibility(sharedConfig.settingsGroupName!, true, o.value as string);
                }}
                name="settings"
                type="sidebar-icons"
                width={16}
                height={16}
                style={{ marginLeft: "auto" }}
              />
            </div>
          );
        },
        dropdownHeader: "ADD NEW",
        onDropdownHeaderClick: (): void => {
          this.updateMcpModalVisibility(sharedConfig.settingsGroupName!, true);
        }
      };
    }

    if (sharedConfig.defaultValue !== undefined && (!parameter.symbol || parameter.symbol.fixedValue === "")) {
      this.updateActionParameter(parameter, {
        fixedValue: sharedConfig.defaultValue,
        category: ESymbolCategory.fixed
      } as ISymbol);
    }

    return returnValue;
  };

  getStartingScreenIdValue = () => {
    const startingScreenId = this.props.action.parameters.find((x) => x.name === "startingScreenId");
    if (startingScreenId?.symbol?.fixedValue && startingScreenId.symbol.fixedValue !== "")
      return startingScreenId.symbol.fixedValue;
    return "";
  };

  onStartingScreenIdValueChanged = (val, check?: boolean) => {
    const parameters = _.cloneDeep(this.props.action.parameters);
    const startingScreenIdParameter = parameters.find((x) => x.name === "startingScreenId");
    if (startingScreenIdParameter) {
      startingScreenIdParameter.symbol = { category: ESymbolCategory.fixed, fixedValue: val } as ISymbol;
      this.updateActionParametersForce(parameters, ESdChangeReason.StartingScreenIdChanged);
    }
  };

  getSelectedRoleNamesValue = () => {
    const roleNames = this.props.action.parameters.find((x) => x.name === "roleNames");
    if (!roleNames?.symbol?.fixedValue) return [];

    return roleNames.symbol.fixedValue.split(",");
  };

  onRoleNamesValueChanged = (val) => {
    const parameters = _.cloneDeep(this.props.action.parameters);
    const roleNamesParameter = parameters.find((x) => x.name === "roleNames");
    if (roleNamesParameter) {
      roleNamesParameter.symbol = { category: ESymbolCategory.fixed, fixedValue: val.toString() } as ISymbol;
      this.updateActionParametersForce(parameters, ESdChangeReason.ActionParameterFixedValueChanged);
    }
  };

  private getWf = (processStepScreen: IProcessStepScreensInfo): IWorkFlow | undefined => {
    let wf: IWorkFlow | undefined;

    if (processStepScreen.projectId && processStepScreen.projectId !== "") {
      const projectWithWf = this.props.sd.projectsWithWFData.find(
        (project) => project.id === processStepScreen?.projectId
      );

      const workflows = projectWithWf?.workflows as IWorkFlowDto[] | undefined;

      wf = workflows?.find((wf) => wf.id === processStepScreen?.processId);
    } else {
      wf = this.props.sd.workFlowList.find((wf) => wf.id === processStepScreen?.processId);
    }

    return wf;
  };

  getChildParameterList = (actionParameter: IActionParameter, actionParamUpdateRequired: boolean) => {
    const parameterList = actionParameter.parameters?.map((childParameter: IActionParameter) => {
      const param: IActionParameter | undefined = KMainFunctions.findParameter(
        this.props.action.parameters,
        childParameter.name
      );

      if (param) {
        if (childParameter.parameters && childParameter.parameters.length > 0) {
          const result = this.getChildParameterList(childParameter, actionParamUpdateRequired);
          param.parameters = result.parameterList;
          actionParamUpdateRequired = result.actionParamUpdateRequired ? true : actionParamUpdateRequired;
        }
        childParameter = param;
      } else {
        actionParamUpdateRequired = true;
      }

      if (!childParameter.symbol) {
        childParameter.symbol = KMainFunctions.getDefaultSymbol(childParameter.Typename);
      }

      return childParameter;
    });
    return { parameterList, actionParamUpdateRequired };
  };

  getParameterList = () => {
    if (!this.props.actionDefinition) {
      return <></>;
    }

    const actionDefinition = _.cloneDeep(this.props.actionDefinition);
    let actionParamUpdateRequired = false;
    let updatedActionParameters = actionDefinition.actionParameters.map((actionDefParam: IActionParameter) => {
      const param: IActionParameter | undefined = this.props.action.parameters.find(
        (p) => p.name === actionDefParam.name
      );

      if (param) {
        if (actionDefParam.parameters && actionDefParam.parameters.length > 0) {
          const result = this.getChildParameterList(actionDefParam, actionParamUpdateRequired);
          param.parameters = result.parameterList;
          actionParamUpdateRequired = result.actionParamUpdateRequired ? true : actionParamUpdateRequired;
        }
        actionDefParam = param;
      } else {
        actionParamUpdateRequired = true;
      }

      if (
        (actionDefinition.name === "NAVIGATE" || actionDefinition.name === "NavigateToTask") &&
        actionDefParam.name === "executePageInitActionsAfterClose" &&
        !actionDefParam?.symbol
      ) {
        actionDefParam.symbol = {
          category: ESymbolCategory.fixed,
          fixedValue: true
        } as ISymbol;
        actionDefParam.symbol.fixedValue = true;
      }
      if (!actionDefParam.symbol) {
        actionDefParam.symbol = KMainFunctions.getDefaultSymbol(actionDefParam.Typename);
      }

      return actionDefParam;
    });

    // Update Json if new parameters added to actionDefinition
    if (
      actionParamUpdateRequired &&
      actionDefinition.name !== "StartProcess" &&
      actionDefinition.name !== "ResumeProcess" &&
      actionDefinition.name !== "SaveStepData" &&
      actionDefinition.name !== "SendMail" &&
      actionDefinition.name !== "SendWhatsappBusinessMessage"
    ) {
      this.updateActionParametersForce(updatedActionParameters);
    }

    if (actionDefinition.name === "NavigateToTask") {
      if (this.props.action.parameters[0].name !== "WorkflowStepInstanceId") {
        this.updateActionParametersForce(updatedActionParameters);
      }
    }

    if (
      actionDefinition.actionType === EDatasourceType.CSharpFunctions ||
      actionDefinition.actionType === EDatasourceType.RestApi ||
      actionDefinition.actionType === EDatasourceType.MsSql ||
      actionDefinition.actionType === EDatasourceType.ManagedDb ||
      actionDefinition.actionType === EDatasourceType.ManagedDbOracle ||
      actionDefinition.actionType === EDatasourceType.ManagedDbPostgre ||
      actionDefinition.actionType === EDatasourceType.Postgre ||
      actionDefinition.name === "GetMyTasks"
    ) {
      if (this.props.action.parameters.length != updatedActionParameters.length) {
        this.updateActionParametersForce(updatedActionParameters);
      }

      updatedActionParameters.forEach((eventMetaActionParam) => {
        const definedActionParameter = actionDefinition?.actionParameters?.find(
          (definedActionParam) => definedActionParam.name === eventMetaActionParam.name
        );
        if (definedActionParameter === undefined) {
          eventMetaActionParam.isDeletedOnSource = true;
        } else if (definedActionParameter?.Typename !== eventMetaActionParam.Typename) {
          eventMetaActionParam.Typename = definedActionParameter.Typename;
        }
      });
    }

    const label = actionDefinition.name;
    const surface: EActionPanelSurface = resolveActionPanelSurface(actionDefinition);
    if (
      label === "StartProcess" ||
      label === "ResumeProcess" ||
      label === "SaveStepData" ||
      label === "StartExternalProcess" ||
      label === "SendWhatsappBusinessMessage" ||
      label === "MigrateProcessInstances" ||
      label == "AnalyzeProcessMigration"
    ) {
      this.props.action.parameters.forEach((p) => {
        const prm = updatedActionParameters?.find((up) => up.name === p.name);
        if (prm === undefined) {
          updatedActionParameters?.push(p);
        }
      });
    }

    if (surface === EActionPanelSurface.workflowStart) {
      const pid = this.props.action.parameters?.find((p) => p.name === "workflow")?.symbol?.fixedValue;
      const projectId = this.props.action.parameters?.find((p) => p.name === "projectId")?.symbol?.fixedValue;

      if (pid !== undefined) {
        const project = this.props.sd.projectsWithWFData.find((p) => p.id == projectId);
        const process =
          projectId && (projectId.length == 0 || projectId === this.props.sd.project.id)
            ? this.props.sd.workFlowList.find((wfl) => wfl.id == pid)
            : (project?.workflows.find((wfl) => wfl.id == pid) as IWorkFlow);
        process?.parameters
          ?.filter((p) => p.isInput === true)
          .forEach((p) => {
            const prm = updatedActionParameters?.find((up) => up.name === p.name);
            if (prm === undefined) {
              updatedActionParameters?.push({
                name: p.name,
                symbol: p.defaultValue as ISymbol,
                cardinality: ECardinality.One,
                Typename: p.dataType
              });
            } else if (prm.Typename !== p.dataType) {
              prm.Typename = p.dataType;
              this.updateActionParameter(prm, p.defaultValue as ISymbol);
              // this.setActionParameterToActionObject(this.props.action, prm, p.defaultValue as ISymbol);
            }
          });

        updatedActionParameters.map((up) => {
          if (!up.isOptionalParameter) {
            const prm = process?.parameters?.find((p) => p.name === up.name && p.isInput === true);
            up.isDeletedOnSource = prm === undefined;
          }
        });
      }
      return (
        <WFStartSymbolsGroup
          key={`wfStartSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          updateParams={this.updateActionParametersForce}
        />
      );
    }
    // VTO: this block is for deprecated action, and will be removed later
    if (surface === EActionPanelSurface.workflowExternalStart) {
      const projectId = this.props.action.parameters?.find((p) => p.name === "projectId")?.symbol?.fixedValue;
      const pid = this.props.action.parameters?.find((p) => p.name === "workflow")?.symbol?.fixedValue;

      if (pid !== undefined) {
        const project = this.props.sd.projectsWithWFData.find((p) => p.id == projectId);
        const wf = project?.workflows.find((wfl) => wfl.id == pid) as IWorkFlow;
        wf?.parameters
          ?.filter((p) => p.isInput === true)
          .forEach((p) => {
            const prm = updatedActionParameters?.find((up) => up.name === p.name);
            if (prm === undefined) {
              updatedActionParameters?.push({
                name: p.name,
                symbol: p.defaultValue as ISymbol,
                cardinality: ECardinality.One,
                Typename: p.dataType
              });
            } else if (prm.Typename !== p.dataType) {
              prm.Typename = p.dataType;
              this.updateActionParameter(prm, p.defaultValue as ISymbol);
            }
          });

        updatedActionParameters.map((up) => {
          const prm = wf?.parameters?.find((p) => p.name === up.name && p.isInput === true);
          up.isDeletedOnSource = prm === undefined;
        });
      }
      return (
        <WFExternalStartSymbolsGroup
          action={this.props.action}
          key={`wfExternalStartSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          updateParams={this.updateActionParametersForce}
        />
      );
    }

    if (surface === EActionPanelSurface.workflowResume) {
      let needUpdate: boolean = false;
      const staticParameters: IActionParameter[] = [
        {
          name: "workflowStepInstanceId",
          symbol: {
            description: "workflowStepInstanceId",
            category: 6,
            label: "Screen Input",
            inputName: "workflowStepInstanceId",
            currentType: "String",
            targetType: "String"
          },
          cardinality: 1,
          Typename: "String"
        },
        {
          name: "userInteractionId",
          symbol: {
            fixedValue: "",
            currentType: "String",
            targetType: "String"
          } as ISymbol,
          cardinality: ECardinality.One,
          Typename: "String"
        },
        {
          name: "isCreatedByWizard",
          symbol: {
            fixedValue: false,
            currentType: "Boolean",
            targetType: "Boolean"
          } as ISymbol,
          cardinality: ECardinality.One,
          Typename: "Boolean"
        }
      ];
      const project = this.props.sd.getProject();
      const screen = this.props.sd.getScreenDesign();
      const screenStepData = project.processStepScreenIds?.find((s) => s.screenId == screen.id);
      let userInteractions: IUserInteraction[] = [];
      let processParameters: IWFParameter[] = [];
      if (screenStepData !== undefined) {
        const process = this.getWf(screenStepData);

        const step = this.props.sd.findStepRecursively(process!, (s) => s.id === screenStepData.stepId);
        userInteractions = step?.userInteractions ?? [];
        processParameters = process?.parameters ?? [];

        step?.outputParameters?.forEach((p) => {
          const wfPrm = process?.parameters?.find((wfp) => wfp.id === p.id);
          const prm = updatedActionParameters?.find((up) => up.name === wfPrm?.name);

          if (prm === undefined && wfPrm !== undefined) {
            updatedActionParameters?.push({
              name: wfPrm.name,
              symbol: _.cloneDeep(p.value as ISymbol),
              cardinality: ECardinality.One,
              Typename: wfPrm.dataType
            });
          }
        });

        let actionDefaultParamIndex: number[] = [];
        updatedActionParameters.map((up) => {
          if (staticParameters.some((sp) => sp.name === up.name)) {
            up.isDeletedOnSource = false;
          } else if (actionDefinition?.actionParameters.some((ap) => ap.name === up.name)) {
            up.isDeletedOnSource = false;
            up.isOptionalParameter = actionDefinition?.actionParameters.find(
              (ap) => ap.name === up.name
            )?.isOptionalParameter;
            actionDefaultParamIndex.push(updatedActionParameters.indexOf(up));
          } else {
            const wfPrm = process?.parameters?.find((wfp) => wfp.name === up.name);
            const prm = step?.outputParameters?.find((p) => p.id === wfPrm?.id);
            up.isDeletedOnSource = prm === undefined;
          }
        });

        const parameterCountToDelete = updatedActionParameters.filter((uap) => uap.isDeletedOnSource).length;
        updatedActionParameters = updatedActionParameters.filter((uap) => !uap.isDeletedOnSource);

        actionDefaultParamIndex
          .sort((a, b) => b - a)
          .forEach((i) => {
            const up = updatedActionParameters[i];
            // if (!up.isExternalVisible) updatedActionParameters.splice(updatedActionParameters.indexOf(up), 1);
            // else
            updatedActionParameters.push(updatedActionParameters.splice(i, 1)[0]);
          });

        if (parameterCountToDelete > 0) {
          needUpdate = true;
        }

        if (!updatedActionParameters.some((p) => p.name === "workflowStepInstanceId")) {
          staticParameters.forEach((s) => updatedActionParameters.push(s));
          needUpdate = true;
        }

        if (needUpdate) {
          this.updateActionParametersForce(updatedActionParameters, ESdChangeReason.WFStepMappingChange);
        }
      }

      return (
        <WFResumeSymbolsGroup
          action={this.props.action}
          key={`wfResumeSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          updateParams={this.updateActionParametersForce}
          userInteractions={userInteractions}
          processParameters={processParameters}
          changeActionParameter={this.updateActionParameter}
          updateAddGoBackAction={this.updateAddGoBackAction}
          addGoBackActionValue={this.props.action.addGoBackAction}
        />
      );
    }
    // GetMyTasksFromProcess (deprecated, VTO: to be removed) and GetUserTasks share this group.
    if (surface === EActionPanelSurface.workflowGenericTasks) {
      const processIdPrm = this.props.action.parameters.find((x) => x.name === "ProcessDefinitionId");
      const selectedProcess = this.props.sd.workFlowList.find((x) => x.id === processIdPrm?.symbol.fixedValue);
      const actionReturnTypes = this.props.action.returnTypeDynamicInterface;

      const selectedProcessParameters = selectedProcess?.parameters?.filter((p) =>
        actionReturnTypes?.elements?.some((t) => t.name == p.name)
      );

      return (
        <WFGenericTasksSymbolsGroup
          key={`wfGenericTasksSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          selectedProcess={selectedProcess}
          selectedProcessParameters={selectedProcessParameters || []}
          updateValues={this.updateValues}
          onActionParameterSelected={this.updateActionParameter}
        ></WFGenericTasksSymbolsGroup>
      );
    }

    if (surface === EActionPanelSurface.workflowGenericProcesses) {
      const processIdPrm = this.props.action.parameters.find((x) => x.name === "ProcessDefinitionId");
      const selectedProcess = this.props.sd.workFlowList.find((x) => x.id === processIdPrm?.symbol.fixedValue);
      const actionReturnTypes = this.props.action.returnTypeDynamicInterface;

      return (
        <WFGenericProcessesSymbolsGroup
          key={`wfGenericProcessesSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          selectedProcess={selectedProcess}
          updateValues={this.updateValues}
          onActionParameterSelected={this.updateActionParameter}
        ></WFGenericProcessesSymbolsGroup>
      );
    }

    if (surface === EActionPanelSurface.workflowMigrateProcess) {
      return (
        <WFMigrateProcessSymbolsGroup
          key={`wfMigrateProcessSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        ></WFMigrateProcessSymbolsGroup>
      );
    }

    // DMS Bulk actions — simplified: just folderId + action-specific params.
    // No custom panel needed — default ActionSymbolWithChild handles these.

    if (surface === EActionPanelSurface.navigation) {
      updatedActionParameters.forEach((parameter) => {
        if (!parameter.symbol) parameter.symbol = { category: ESymbolCategory.fixed } as ISymbol;
      });
      const fromScreenIdParam = updatedActionParameters.find((x) => x.name === "fromScreenId");
      if (fromScreenIdParam && !fromScreenIdParam.symbol?.fixedValue) {
        fromScreenIdParam.symbol.fixedValue = this.props.sd.sdId;
      }
      const openAsParam = updatedActionParameters.find((x) => x.name === "openAs");
      if (openAsParam && !openAsParam.symbol?.fixedValue) {
        openAsParam.symbol.fixedValue = "currentPage";
      }

      if (label === "NavigateToTask") {
        const toScreenIdParam = updatedActionParameters.find((x) => x.name === "toScreenId");
        if (toScreenIdParam && !toScreenIdParam.symbol?.fixedValue) {
          toScreenIdParam.symbol.fixedValue = undefined;
        }
      }

      return (
        <NavigationSymbolsGroup
          key={`navigationSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          targetScreenInputParams={this.props.action.targetScreenInputParams ?? []}
          updateValues={this.updateValues}
          deleteTargetScreenInputParams={this.deleteTargetScreenInputParams}
        />
      );
    }

    if (surface === EActionPanelSurface.setValue) {
      return (
        <SetValueSymbolsGroup
          key={`setValueSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.componentToPdf) {
      return (
        <ComponentToPdfSymbolGroup
          key={`componentToPdfSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }
    if (surface === EActionPanelSurface.setVisible) {
      return (
        <SetVisibleSymbolsGroup
          key={`setVisibleSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.setEnabled) {
      return (
        <SetEnabledSymbolsGroup
          key={`setEnabledSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.toggleEnableVisible) {
      return (
        <SetToogleEnableVisibleSymbolsGroup
          key={`setToogleEnableVisibleSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }
    if (surface === EActionPanelSurface.toggleMenuCollapse) {
      return (
        <SetToogleEnableVisibleSymbolsGroup
          key={`setToogleEnableVisibleSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          menu
        />
      );
    }

    if (surface === EActionPanelSurface.collapsePanel) {
      return (
        <SetCollapsePanelSymbolsGroup
          key={`setCollapsePanelSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.selectElementId) {
      return (
        <SelectElementIdSymbolGroup
          key={`selectElementIdSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }
    if (surface === EActionPanelSurface.photo) {
      return (
        <PhotoTakeymbolsGroup
          key={`photoTakeymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.ifThenElse) {
      return (
        <IfThenElseConditionSymbolGroup
          action={this.props.action}
          condition={this.props.action?.ifThenElseData?.condition}
          updateCondition={this.updateIfThenElseDataCondition}
        />
      );
    }

    if (surface === EActionPanelSurface.stripePaymentIntent) {
      return (
        <StripePaymentIntentSymbolsGroup
          key={`stripePaymentIntentSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.stripeSetupIntent) {
      return (
        <StripeSetupIntentSymbolsGroup
          key={`stripeSetupIntentSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.notify) {
      return (
        <NotifySymbolsGroup
          key={`notifySymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.updateUserStartingScreen) {
      return (
        <UpdateUserStartingScreenSymbolsGroup
          action={this.props.action}
          key={`updateUserStartingScreenSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.stripeChargeSetupIntent) {
      return (
        <StripeChargeSetupIntentSymbolsGroup
          key={`stripeChargeSetupIntentSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.saveSource) {
      return (
        <SaveSourceSymbolsGroup
          action={this.props.action}
          key={`saveSourceSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.saveActionResult) {
      return (
        <SaveActionResultSymbolsGroup
          key={`saveActionResultSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.search) {
      return (
        <SearchSymbolsGroup
          key={`searchSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.documentParameters) {
      return (
        <DocumentParametersSymbolsGroup
          key={`documentParametersSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={this.props.action.parameters}
          updateValues={this.updateValues}
          updateActionParametersForce={this.updateActionParametersForce}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if (surface === EActionPanelSurface.sendMail) {
      return (
        <SendMailWithTemplateSymbolsGroup
          key={`sendMailWithTemplateSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={this.props.action.parameters}
          updateValues={this.updateValues}
          updateActionParametersForce={this.updateActionParametersForce}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if (surface === EActionPanelSurface.sendPushNotification) {
      return (
        <SendPushNotificationSymbolsGroup
          key={`sendPushNotificationSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
          targetScreenInputParams={this.props.action.targetScreenInputParams ?? []}
          deleteTargetScreenInputParams={this.deleteTargetScreenInputParams}
        />
      );
    }

    if (surface === EActionPanelSurface.printReport) {
      return (
        <PrintReportSymbolsGroup
          key={`printReportSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={this.props.action.parameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
          targetScreenInputParams={this.props.action.targetScreenInputParams ?? []}
          deleteTargetScreenInputParams={this.deleteTargetScreenInputParams}
        />
      );
    }

    if (surface === EActionPanelSurface.multiReportPrint) {
      return (
        <MultiReportPrintSymbolsGroup
          key={`multiReportPrintSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          multiReportData={this.props.action.multiReportData}
          updateMultiReportData={this.updateMultiReportData}
        />
      );
    }

    if (surface === EActionPanelSurface.triggerEvent) {
      return (
        <TriggerEventSymbolsGroup
          key={`triggerEventSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          action={this.props.action}
          updateActionParameter={this.updateActionParameter}
          updateActionDescriptionWithParameters={this.updateActionDescriptionWithParameters}
        />
      );
    }

    if (surface === EActionPanelSurface.openInBrowser) {
      return (
        <OpenInBrowserSymbolsGroup
          key={`openInBrowserSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={this.props.action.parameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if (surface === EActionPanelSurface.tableConfig) {
      return (
        <TableConfigSymbolsGroup
          key={`tableConfigSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if (surface === EActionPanelSurface.nodeTreeExport) {
      return (
        <NodeTreeExportSymbolsGroup
          key={`nodeTreeExportSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if ((label === "AddUserToRole" || label === "RemoveUserFromRole") && !this.props.sd?.project?.roles) {
      return (
        <KuikaSmallMediumText style={{ color: "var(--red-5)", marginTop: 5 }}>
          Add a role to the project to use this action
        </KuikaSmallMediumText>
      );
    }

    if (surface === EActionPanelSurface.openPdf) {
      const openAsParam = updatedActionParameters.find((x) => x.name === "openAs");

      if (openAsParam && !openAsParam.symbol?.fixedValue) {
        openAsParam.symbol.fixedValue = "newTab";
      }

      return (
        <OpenPdfSymbolsGroup
          key={`openPdfSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          targetScreenInputParams={this.props.action.targetScreenInputParams ?? []}
          updateValues={this.updateValues}
          deleteTargetScreenInputParams={this.deleteTargetScreenInputParams}
          changeActionParameter={this.updateActionParameter}
        />
      );
    }

    if (surface === EActionPanelSurface.managedDbSave) {
      return (
        <ManagedDbSaveSymbolGroup
          key={`managedDbSaveSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          managedDbData={this.props.action.managedDbData}
          updateManagedDbData={this.updateManagedDbData}
        />
      );
    }

    if (surface === EActionPanelSurface.managedDbDelete) {
      return (
        <ManagedDbDeleteSymbolGroup
          key={`managedDbDeleteSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          managedDbData={this.props.action.managedDbData}
          updateManagedDbData={this.updateManagedDbData}
        />
      );
    }

    if (surface === EActionPanelSurface.recurringActions) {
      return (
        <RecurringActionsSymbolGroup
          key={`recurringActionsSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
          recurringActionsData={this.props.action.recurringActionsData}
          updateRecurringActionsData={this.updateRecurringActionsData}
          getActionDefinitionItems={this.props.getActionDefinitionItems}
        />
      );
    }

    if (surface === EActionPanelSurface.mqttSubscribe) {
      return (
        <MqttSubscribeActionsSymbolGroup
          action={this.props.action}
          key={`mqttSubscribeActionsSymbolGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
          mqttSubscribeActionData={this.props.action.mqttSubscribeActionData}
          updateMqttSubscribeActionsData={this.updateMqttSubscribeActionsData}
          getActionDefinitionItems={this.props.getActionDefinitionItems}
        />
      );
    }

    if (surface === EActionPanelSurface.importMappedExcel) {
      const standardParams: readonly string[] = IMPORT_MAPPED_EXCEL_STANDARD_PARAMETERS;

      const customParametersFromAction: IActionParameter[] = this.props.action.parameters.filter(
        (p) => !standardParams.includes(p.name) && !updatedActionParameters.find((up) => up.name === p.name)
      );

      const allParameters: IActionParameter[] = [...updatedActionParameters, ...customParametersFromAction];
      const customParameters: IActionParameter[] = allParameters.filter((p) => !standardParams.includes(p.name));

      return (
        <>
          <ImportMappedExcelSymbolsGroup
            key={`importMappedExcelSymbolsGroup_${this.props.action.id}`}
            parameters={updatedActionParameters}
            updateValues={this.updateValues}
          />
          {customParameters.map((parameter: IActionParameter, index) => (
            <ActionSymbolWithChild
              key={`actionSymbolWithChild-${this.props.action.id}-${parameter.name}-${index}`}
              action={_.cloneDeep(this.props.action)}
              parameter={_.cloneDeep(parameter)}
              actionDefinition={actionDefinition}
              actionPanelStatus={this.props.actionPanelStatus}
              getSelectboxParameter={(parameter) => this.getSelectboxParameter(actionDefinition, parameter)}
              onActionSaved={this.triggerOnActionSaved}
              onActionParameterSelected={this.updateActionParameter}
              onDeleteParameter={this.deleteParameterSave}
            />
          ))}
        </>
      );
    }

    if (surface === EActionPanelSurface.confirmation) {
      return (
        <ConfirmationSymbolGroup
          key={`confirmationSymbolGroup_${this.props.action.id}`}
          action={this.props.action}
          onActionSaved={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.sendWhatsappBusinessMessage) {
      const selectedWf = this.props.sd.selectedWf;
      const selectedStep = this.props.sd.getSelectedWfStep();
      let interactions: IUserInteraction[] = [];

      if (selectedStep) {
        if (selectedStep?.assignment.assignmentType === EWFAssignmentType.external) {
          interactions =
            selectedStep?.userInteractions?.filter(
              (p) => p.parameters.length === selectedStep.outputParameters.length
            ) || [];
        }
      }

      if (selectedWf && selectedStep) {
        const allInteractionLinksParam = updatedActionParameters.find((x) => x.name === "allInteractionLinks");
        if (allInteractionLinksParam && allInteractionLinksParam.symbol?.fieldName !== "allInteractionLinks") {
          allInteractionLinksParam.symbol = {
            category: ESymbolCategory.processParameter,
            currentType: "String",
            description: "allInteractionLinks",
            fieldName: "allInteractionLinks",
            fieldType: "String",
            inputName: "allInteractionLinks",
            targetType: "String"
          } as ISymbol;

          this.updateValues({ actionParameters: updatedActionParameters });
        }
      }

      return (
        <SendWhatsappBusinessMessageSymbolsGroup
          action={this.props.action}
          key={`sendWhatsappBusinessMessageSymbolsGroup_${this.props.action.id}`}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
          changeActionParameter={this.updateActionParameter}
          interactions={interactions}
          updateParams={this.updateActionParametersForce}
        />
      );
    }

    if (surface === EActionPanelSurface.getEntityValueFromDynamicForm) {
      return (
        <GetEntityValueFromDynamicFormSymbolsGroup
          key={`getEntityValueFromDynamicFormSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.clearDynamicForm) {
      return (
        <ClearDynamicFormSymbolsGroup
          key={`clearDynamicFormSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.setEntityAttributeValueInDynamicForm) {
      return (
        <SetEntityAttributeValueInDynamicFormSymbolsGroup
          key={`setEntityAttributeValueInDynamicFormSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.getEntityAttributeValueInDynamicForm) {
      return (
        <GetEntityAttributeValueInDynamicFormSymbolsGroup
          key={`getEntityAttributeValueInDynamicFormSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.getIsDynamicFormValid) {
      return (
        <GetIsDynamicFormValidSymbolsGroup
          key={`getIsDynamicFormValidSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.getFromBag) {
      let addToBagAction: IAction | undefined;
      const allActions = CommonHelperFunctions.getAllActions(this.props.sd.getScreenDesign().displayItems ?? []);
      const key = this.props.action.parameters.find((x) => x.name === "key")?.symbol?.fixedValue;

      if (key) {
        addToBagAction = allActions.find(
          (x) => x.label === "AddToBag" && x.parameters.find((p) => p.name === "key")?.symbol?.fixedValue === key
        );
      }

      return (
        <GetFromBagSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
          addToBagAction={addToBagAction ?? null}
        />
      );
    }

    if (surface === EActionPanelSurface.removeFromBag) {
      return (
        <RemoveFromBagSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.bagHasKey) {
      return (
        <BagHasKeySymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.addToBag) {
      return (
        <AddToBagSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.fetchFromCache) {
      let pushToCacheAction: IAction | undefined;
      const allActions = CommonHelperFunctions.getAllActions(this.props.sd.getScreenDesign().displayItems ?? []);
      const key = this.props.action.parameters.find((x) => x.name === "key")?.symbol?.fixedValue;

      if (key) {
        pushToCacheAction = allActions.find(
          (x) => x.label === "PushToCache" && x.parameters.find((p) => p.name === "key")?.symbol?.fixedValue === key
        );
      }

      return (
        <FetchFromCacheSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
          pushToCacheAction={pushToCacheAction ?? null}
        />
      );
    }

    if (surface === EActionPanelSurface.pushToCache) {
      return (
        <PushToCacheSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.cacheHasKey) {
      return (
        <CacheHasKeySymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    if (surface === EActionPanelSurface.toggleLayout) {
      return (
        <ToggleLayoutSymbolsGroup
          key={`toggleLayoutSymbolsGroup_${this.props.action.id}`}
          action={this.props.action}
          parameters={updatedActionParameters}
          updateValues={this.updateValues}
        />
      );
    }

    if (surface === EActionPanelSurface.removeFromCache) {
      return (
        <RemoveFromCacheSymbolsGroup
          action={this.props.action}
          parameters={updatedActionParameters}
          onSaveAction={this.triggerOnActionSaved}
        />
      );
    }

    return updatedActionParameters
      ?.filter((parameter: IActionParameter): boolean => isActionParameterShownInPanel(parameter))
      ?.map((parameter: IActionParameter, index) => {
        // Footer switches (a JS action's runOnServer, GetAuditLogs' onlyCurrentProject) are not rows.
        // Skipped inside the map, not filtered, so the rows' index-based keys stay put.
        if (isFooterToggleParameter(actionDefinition, parameter.name)) {
          return null;
        }

        return (
          <ActionSymbolWithChild
            key={`actionSymbolWithChild-${this.props.action.id}-${parameter.name}-${index}`}
            action={_.cloneDeep(this.props.action)}
            parameter={_.cloneDeep(parameter)}
            actionDefinition={actionDefinition}
            actionPanelStatus={this.props.actionPanelStatus}
            getSelectboxParameter={(parameter) => this.getSelectboxParameter(actionDefinition, parameter)}
            onActionSaved={this.triggerOnActionSaved}
            onActionParameterSelected={this.updateActionParameter}
            onDeleteParameter={this.deleteParameterSave}
          />
        );
      });
  };

  deleteParameterSave = (parameterName: string) => {
    const action = _.clone(this.props.action);
    const newParameters = action.parameters.filter((p) => p.name !== parameterName);
    action.parameters = newParameters;
    this.triggerOnActionSaved(action, ESdChangeReason.DiActionUpdated);
  };

  deleteTargetScreenInputParams = (screenInputName: string) => {
    const action = _.clone(this.props.action);
    // An action that never had a target screen picked carries no list at all (KOA-18448).
    const targetScreenInputParams = (action.targetScreenInputParams ?? []).filter((p) => p.name !== screenInputName);
    action.targetScreenInputParams = targetScreenInputParams;
    this.triggerOnActionSaved(action, ESdChangeReason.DiActionUpdated);
  };

  getSelectedKuikaIds = () => {
    if (
      this.props.sd.dashboardState === DashboardState.dataDiagramScheme ||
      this.props.sd.dashboardState === DashboardState.workFlow
    ) {
      return ["-1"];
    }
    return this.props.sd.selectedKuikaIds;
  };

  handleActionConfirmation = (
    confirmationMessage: string | undefined,
    fontFamily: string | undefined,
    confirmationHeader: string | undefined,
    confirmationIcon: string | undefined,
    confirmationIconBackgroundColor: string | undefined,
    confirmationConfirmButtonColor: string | undefined,
    confirmationCancelButtonColor: string | undefined
  ) => {
    this.updateConfirmation(
      confirmationMessage,
      fontFamily,
      confirmationHeader,
      confirmationIcon,
      confirmationIconBackgroundColor,
      confirmationConfirmButtonColor,
      confirmationCancelButtonColor
    );
  };

  handleRecurringInterval = (recurringInterval: number) => {
    this.updateRecurringInterval(recurringInterval);
  };

  handleActionCondition = (condition: IConditionModel | undefined, changeReason?: ESdChangeReason | undefined) => {
    this.updateCondition(condition, changeReason);
  };

  handleActionMenuVisibleChange = (visible: boolean) => {
    this.tagInputRef.current?.blur();
    this.setState({ visibleActionMenu: visible });
  };

  getActionName = (isDisplay: boolean) => {
    if (!this.props.actionDefinition) return this.props.action.description;
    if (!isDisplay) return this.props.actionDefinition.displayName ?? this.props.actionDefinition.name;
    return KMainFunctions.getFormattedSystemActionName(this.props.actionDefinition);
  };

  /**
   * The subtitle under the action's title — "AirbnbResponse · One", or just "AirbnbResponse" when
   * the action carries no cardinality. Was a parenthetical, italic "AirbnbResponse (One)"; only
   * the presentation changed, not which of the action's own vs. its definition's return type/
   * cardinality wins (the action's own value, when set, still takes priority below).
   */
  getActionReturnInfo = () => {
    const returnType = this.props.action.returnType?.split(".").slice(-1).pop();
    const returnCardinalityLabel: string | undefined = this.props.action.returnCardinality
      ? ECardinality[this.props.action.returnCardinality]
      : undefined;

    if (returnType) {
      return this.renderActionReturnInfo(
        returnCardinalityLabel ? `${returnType} · ${returnCardinalityLabel}` : returnType
      );
    }

    const returnTypeInDef = this.props.sd.actionDefinitions
      .find((a) => a.id === this.props.action.actionDefinitionId)
      ?.returnTypeName?.split(".")
      .slice(-1)
      .pop();

    const returnCardinalityInDef = this.props.sd.actionDefinitions.find(
      (a) => a.id === this.props.action.actionDefinitionId
    )?.returnCardinality;

    const returnCardinalityInDefLabel: string | undefined = returnCardinalityInDef
      ? ECardinality[returnCardinalityInDef]
      : undefined;

    // No return info at all — no subtitle, not an empty styled row.
    if (!returnTypeInDef) {
      return null;
    }

    return this.renderActionReturnInfo(
      returnCardinalityInDefLabel ? `${returnTypeInDef} · ${returnCardinalityInDefLabel}` : returnTypeInDef
    );
  };

  /** A long generated type name fades and slides on hover like the title above it, not a hard clip. */
  renderActionReturnInfo = (returnInfo: string): JSX.Element => (
    <KuikaSmallText className="kuika-action-card__subtitle" title={returnInfo}>
      <KuikaOverflowText>{returnInfo}</KuikaOverflowText>
    </KuikaSmallText>
  );

  getActionTagInfo = () => {
    const tag: string | null | undefined = this.props.action.tag;
    // Bag and Cache actions have no tag menu: their tag is the key they read, filled in from it. It
    // is still the only thing telling two collapsed Get From Bag cards apart (KOA-16209).
    const isTagVisible: boolean =
      this.props.actionDefinition?.isTagDisabled !== true && tag !== null && tag !== undefined && tag.trim() !== "";

    if (!isTagVisible) return null;

    return (
      <span title={tag as string} className="kuika-action-card__tag">
        <KuikaTag type="action" label={tag as string} dataTestId="actionTagChip" truncate="middle" />
      </span>
    );
  };

  handleDontTriggerValidations = (dontTriggerValidations: boolean) => {
    this.updateDontTriggerValidations(dontTriggerValidations);
  };

  handleIsAuditEnabled = (isAuditEnabled: boolean) => {
    const action = setDesignerActionAuditEnabled(this.props.action, isAuditEnabled);
    this.triggerOnActionSaved(action);
  };

  toggleActionEnabled = (e: any): void => {
    e?.domEvent?.stopPropagation();
    const nextEnabled: boolean = this.props.action.enabled === false;
    const action: IAction = setDesignerActionEnabled(this.props.action, nextEnabled);
    this.triggerOnActionSaved(action);
  };

  handleAuditLevelChange = (auditLevel: string) => {
    const result = setDesignerActionAuditLevel(this.props.action, auditLevel);
    this.triggerOnActionSaved(result.action, result.changeReason);
  };

  editImportExcelAction = () => {
    const targetKuikaId: string = this.props.sd.selectedKuikaIds[0];
    const targetActionId: string = this.props.action.id;
    const dsId: string = this.props.action.parameters.find((x) => x.name === "dsId")?.symbol?.fixedValue ?? "";
    const tableName: string =
      this.props.action.parameters.find((x) => x.name === "tableName")?.symbol?.fixedValue ?? "";
    const primaryKey: string =
      this.props.action.parameters.find((x) => x.name === "primaryKey")?.symbol?.fixedValue ?? "";

    const mappedColumnsParameter = this.props.action.parameters.find((x) => x.name === "mappedColumns");
    let mappedColumns: IImportMappedExcelColumnMap[] = [];

    if (mappedColumnsParameter) {
      if (!_.isEmpty(mappedColumnsParameter.symbol.fixedValue)) {
        mappedColumns = JSON.parse(mappedColumnsParameter.symbol.fixedValue);
      } else {
        mappedColumns = [];
      }
    } else {
      mappedColumns = [];
    }

    // Extract custom parameters (parameters that are not standard ones)
    const standardParams = ["dsId", "tableName", "primaryKey", "mappedColumns"];
    const parameters = this.props.action.parameters
      .filter((p) => !standardParams.includes(p.name))
      .map((p) => ({
        id: _.uniqueId("param_"),
        name: p.name,
        type: p.Typename
      }));

    this.props.sd.setImportMappedExcelSetupWizardOpen(true, {
      targetKuikaId,
      targetActionId,
      dsId,
      tableName,
      primaryKey,
      mappedColumns,
      parameters
    });
    this.setState({ visibleActionMenu: false });
  };

  editSelectAction = () => {
    if (this.props.actionDefinition) this.props.sd.setActionToEditOnActionPanel(this.props.actionDefinition);
    this.setState({ visibleActionMenu: false });
  };

  copySqlActionQueryWithParameters = (): void => {
    this.setState({ visibleActionMenu: false });
    if (!this.props.actionDefinition) {
      return;
    }
    const result: ISqlActionQueryCopyResult = buildSqlActionQueryWithParameters(
      this.props.actionDefinition,
      this.props.action
    );
    // Through the designer's clipboard helper, which falls back when the Clipboard API is refused.
    // The menu closes on the click, so there is no control left to confirm on: the toast is it.
    void copyTextToClipboard(result.query).then((succeeded: boolean): void => {
      if (!succeeded) {
        toast.error("Clipboard access was denied by the browser.", "Could not copy the query");
        return;
      }
      // The counts matter: unresolved parameters stay as placeholders, so the
      // reader knows how many values they still have to fill in themselves.
      toast.success(
        `${result.resolvedParameterCount} of ${result.totalParameterCount} parameter values filled in.`,
        "Query copied"
      );
    });
  };

  getActiveKey = (): string => {
    if (this.isExpandedPanel === true || this.props.actionPanelStatus === EActionPanelStatus.new) {
      return "1";
    }
    return "";
  };

  changeCollapse = () => {
    if (this.props.isDragging === true) return;

    if (this.isExpandedPanel === false) {
      this.onExpand();
    } else {
      this.onCollapse();
    }
  };

  onCollapse = () => {
    // Saves a tag typed into the tag input that never blurred (KOA-10106). Only a mounted input has
    // one: Bag and Cache cards draw none, their tag being the key they read, and copying the missing
    // input's `undefined` over it erased that key on every close (KOA-16209).
    const tagInput: HTMLInputElement | null = this.tagInputRef.current;
    if (
      tagInput !== null &&
      this.props.action.tag !== null &&
      this.props.action.tag !== undefined &&
      this.props.action.tag !== tagInput.value
    ) {
      this.updateActionTag(tagInput.value);
    }
    this.updateActionIsExpandedPanel(false);
  };

  onExpand = (callback?: any) => {
    this.updateActionIsExpandedPanel(true, callback);
  };

  onOptionalParameterSave = (optionalParameters: IActionParameter[]) => {
    let action = _.cloneDeep(this.props.action);

    optionalParameters.forEach((parameter) => {
      const actionParam = action.parameters.find((p) => p.name === parameter.name);

      if (actionParam) {
        // Update existing parameter
        actionParam.isExternalVisible = parameter.isExternalVisible;

        if (!parameter.isExternalVisible) {
          actionParam.symbol.category = ESymbolCategory.fixed;
          actionParam.symbol.fixedValue = undefined;
          actionParam.symbol.description = "";
        }
      } else {
        // Add new parameter if it doesn't exist in action.parameters
        action.parameters.push({
          ...parameter,
          symbol: parameter.symbol || KMainFunctions.getDefaultSymbol(parameter.Typename)
        });
      }
    });

    this.triggerOnActionSaved(action, ESdChangeReason.DiActionUpdated);
  };

  /** The drag-handle props react-beautiful-dnd's `Draggable` hands `event-panel.tsx` — now bound
   *  to the header's grip glyph rather than spread across the whole header row (still `undefined`,
   *  not a functioning handle, while the panel is expanded). */
  getDragDropProps = (): DraggableProvidedDragHandleProps | undefined => {
    if (this.isExpandedPanel === true) {
      return undefined;
    }
    return this.props.provided?.dragHandleProps;
  };

  getSelectedComponentToChangeName = (allDi: IDisplayItem[], allMasterDi: IDisplayItem[]) => {
    let selectValue;
    const _parameter = this.props.action?.parameters?.find(
      (p) => p?.name === "componentName" || p?.name === "targetDiName" || p?.name === "element"
    );
    if (_parameter && _parameter.symbol) {
      const { fixedValue } = _parameter.symbol;
      allDi?.forEach((di, i) => {
        if (di.id.toString() === fixedValue.toString()) {
          selectValue = di.friendlyName;
        }
      });
      // allMasterDi?.forEach((di, i) => {
      //   if (di.id.toString() === fixedValue.toString()) {
      //     selectValue = `${di.friendlyName} (Master)`;
      //   }
      // });
    }
    return selectValue;
  };

  /** The action's Kuika Academy page, from its `doc` block — none when the action has no documented page. */
  getActionHelpLink = (actionDefinition: IActionDefinitionDto) => {
    const docUrl: string | undefined = getActionDocUrl(actionDefinition);
    if (!docUrl) return null;
    const isMainAI = KMainFunctions.isMainAI();
    if (isMainAI) return null;
    return (
      <a href={docUrl} target="_blank" rel="noopener noreferrer">
        <svg
          style={{ width: 16, height: 16 }}
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 5C9 7.20946 7.20946 9 5 9C2.79054 9 1 7.20946 1 5C1 2.79054 2.79054 1 5 1C7.20946 1 9 2.79054 9 5Z"
            stroke="var(--dark-6)"
            strokeMiterlimit="10"
          />
          <path
            d="M5.43249 3.27026C5.43249 3.50928 5.23908 3.70269 5.00006 3.70269C4.76104 3.70269 4.56763 3.50928 4.56763 3.27026C4.56763 3.03124 4.76104 2.83783 5.00006 2.83783C5.23908 2.83783 5.43249 3.03124 5.43249 3.27026Z"
            fill="var(--dark-6)"
          />
          <path d="M5 4.67569V7.05407" stroke="var(--dark-6)" strokeMiterlimit="10" strokeLinecap="round" />
        </svg>
      </a>
    );
  };

  getSqlLikeSettings = (action: IAction) => {
    if (
      this.props.actionDefinition?.actionType === EDatasourceType.MsSql ||
      this.props.actionDefinition?.actionType === EDatasourceType.ManagedDb ||
      this.props.actionDefinition?.actionType === EDatasourceType.ManagedDbOracle ||
      this.props.actionDefinition?.actionType === EDatasourceType.ManagedDbPostgre ||
      this.props.actionDefinition?.actionType === EDatasourceType.Postgre
    ) {
      if (this.props.actionDefinition?.statement.toLowerCase().includes(" like ")) {
        return (
          <div className="kuika_switch_property" style={{ marginTop: 16 }}>
            <KuikaInfoBox
              leftUnit={
                <div className="kuika-flex--gap-xs">
                  <KuikaSvg name="info-circle" />
                  <KuikaSmallText>
                    Your action contains a LIKE statement. You can set the following options for values to use in LIKE
                  </KuikaSmallText>
                </div>
              }
            ></KuikaInfoBox>
            <div style={{ marginTop: 5 }}>
              <KuikaTabs
                value={action.sqlLikeSetting || "SW"}
                onChange={(value) => this.updateSqlLikeSetting(value)}
                options={[
                  {
                    value: "SW",
                    label: <KuikaSmallText style={{ whiteSpace: "nowrap" }}>Starts with</KuikaSmallText>
                  },
                  {
                    value: "C",
                    label: <KuikaSmallText>Contains</KuikaSmallText>
                  },
                  {
                    value: "EW",
                    label: <KuikaSmallText style={{ whiteSpace: "nowrap" }}>Ends with</KuikaSmallText>
                  },
                  {
                    value: "N",
                    label: <KuikaSmallText>None</KuikaSmallText>
                  }
                ]}
              />
            </div>
          </div>
        );
      }
    } else {
      return <></>;
    }
  };

  updateSqlLikeSetting = (value) => {
    const action = setDesignerActionSqlLikeSetting(this.props.action, value);
    this.triggerOnActionSaved(action, ESdChangeReason.DiActionUpdated);
  };

  moveActionUp = () => {
    if (this.props.moveActionUp) {
      this.props.moveActionUp();
    }
  };

  moveActionDown = () => {
    if (this.props.moveActionDown) {
      this.props.moveActionDown();
    }
  };

  render() {
    if (!this.props.action) {
      return <></>;
    }

    const actionDefinition = this.props.actionDefinition;
    const sd: IScreenDesign = this.props.sd?.getScreenDesign();
    let allDi: IDisplayItem[] = ScreenDesignHelper.getAllChildrenForDisplayItems(sd.displayItems);
    let allMasterDi: IDisplayItem[] = [];

    const isBabyStar = this.props.sd.project.domainId.toUpperCase() === "FE80BF08-DFF9-44F8-91D9-4B5EAB68EB7B";

    const actionMenu = [
      ...(this.props.action.label !== "Confirmation"
        ? [
            this.state.confirmationVisible === true ||
            (this.props.action.confirmationMessage && this.props.action.confirmationMessage.length > 0)
              ? {
                  key: "3",
                  label: "Remove Confirmation",
                  onClick: (e: any) => this.removeConfirmationSelectedItem(e),
                  group: 1
                }
              : {
                  key: "4",
                  label: "Add Confirmation",
                  onClick: (e: any) => this.addConfirmationSelectedItem(e),
                  group: 1
                }
          ]
        : []),

      ...(this.props.action.label !== "IfThenElse"
        ? [
            this.props.action.condition === undefined
              ? {
                  key: "5",
                  label: "Add Condition",
                  onClick: (e: any) => this.addConditionSelectedItem(e),
                  group: 1
                }
              : {
                  key: "6",
                  label: "Remove Condition",
                  onClick: (e: any) => this.removeConditionSelectedItem(e),
                  group: 1
                }
          ]
        : []),

      ...(this.state.recurringVisible === true || this.props.action.isRecurring
        ? [
            {
              key: "7",
              label: "Remove Recurring",
              onClick: (e: any) => this.removeRecurringSelectedItem(e),
              group: 1
            }
          ]
        : isBabyStar
          ? [
              {
                key: "8",
                label: "Set as Recurring",
                onClick: (e: any) => this.addRecurringSelectedItem(e),
                group: 1
              }
            ]
          : []),

      ...(this.props.moveActionUp
        ? [
            {
              key: "8",
              label: "Move Up",
              onClick: (e: any) => this.moveActionUp(),
              group: 4
            }
          ]
        : []),
      ...(this.props.moveActionDown
        ? [
            {
              key: "8",
              label: "Move Down",
              onClick: (e: any) => this.moveActionDown(),
              group: 4
            }
          ]
        : []),

      ...(this.props.actionDefinition &&
      ((this.props.actionDefinition.actionType === EDatasourceType.ManagedDb &&
        this.props.actionDefinition.actionCategory !== EActionCategory.ManagedDb) ||
        (this.props.actionDefinition.actionType === EDatasourceType.ManagedDbPostgre &&
          this.props.actionDefinition.actionCategory !== EActionCategory.ManagedDb) ||
        (this.props.actionDefinition.actionType === EDatasourceType.ManagedDbOracle &&
          this.props.actionDefinition.actionCategory !== EActionCategory.ManagedDb) ||
        this.props.actionDefinition.actionType === EDatasourceType.CustomDb ||
        this.props.actionDefinition.actionType === EDatasourceType.Oracle ||
        this.props.actionDefinition.actionType === EDatasourceType.Postgre ||
        this.props.actionDefinition.actionType === EDatasourceType.Blockly)
        ? [
            {
              key: "9",
              label:
                this.props.actionDefinition.genericSelectData &&
                this.props.actionDefinition.genericSelectData.statementData?.isConvertedToSql !== true
                  ? "Edit Select Action"
                  : this.props.actionDefinition.actionType === EDatasourceType.Blockly
                    ? "Edit Blockly Action"
                    : "Edit SQL Action",
              onClick: () => this.editSelectAction(),
              group: 2
            }
          ]
        : []),

      ...(canCopySqlActionQuery(this.props.actionDefinition)
        ? [
            {
              key: "copy-sql-query-with-parameters",
              label: "Copy query with parameters",
              onClick: () => this.copySqlActionQueryWithParameters(),
              group: 2
            }
          ]
        : []),

      ...(this.props.actionDefinition && this.props.actionDefinition.name === "ImportMappedExcel"
        ? [
            {
              key: "10",
              label: "Edit Import Action",
              onClick: () => this.editImportExcelAction(),
              group: 2
            }
          ]
        : []),

      {
        key: "11",
        label: "Copy",
        onClick: (e: any) => this.copySelectedItem(e),
        group: 2
      },

      ...(this.props.preventActionRemoval
        ? []
        : [
            {
              key: "cut",
              label: "Cut",
              onClick: (e: any) => this.cutSelectedItem(e),
              group: 2
            }
          ]),

      ...(localStorage.getItem("ENABLE_KUIKA_DEV_TOOLS") === "true"
        ? [
            {
              key: "dev-copy-action-json",
              label: "[DEV] Copy Action Json",
              onClick: (): void => {
                const actionJson: string = JSON.stringify(this.props.action, null, 2);
                void copyTextToClipboard(actionJson);
              },
              group: 2
            }
          ]
        : []),

      ...(this.props.context.getClipboardValue("action")
        ? [
            {
              key: "12",
              label: "Paste",
              onClick: (e: any) => this.pasteSelectedItem(e),
              group: 2
            }
          ]
        : []),

      ...(this.props.actionDefinition?.actionCategory !== EActionCategory.Bag &&
      this.props.actionDefinition?.actionCategory !== EActionCategory.Cache &&
      this.props.sd.dashboardState !== DashboardState.scheduledJobs &&
      this.props.actionDefinition?.isTagDisabled !== true
        ? this.props.action.tag !== null && this.props.action.tag !== undefined
          ? [
              {
                key: "13",
                label: "Remove tag name",
                onClick: (e: any) => {
                  e?.domEvent?.stopPropagation();
                  if (this.tagInputRef.current) {
                    this.tagInputRef.current.value = "";
                  }
                  this.updateActionTag(null);
                },
                group: 3
              }
            ]
          : [
              {
                key: "14",
                label: "Add tag name",
                onClick: (e: any) => {
                  e?.domEvent?.stopPropagation();
                  if (this.tagInputRef.current) {
                    this.tagInputRef.current.value = "";
                  }
                  this.updateActionTag("");
                },
                group: 3
              }
            ]
        : []),

      ...(this.props.action.note
        ? [
            {
              key: "note-view",
              label: "View Note",
              onClick: (e: any) => {
                e?.domEvent?.stopPropagation();
                this.setState({ notePopoverVisible: true, visibleActionMenu: false });
              },
              group: 3
            },
            {
              key: "note-remove",
              label: "Remove Note",
              onClick: (e: any) => {
                e?.domEvent?.stopPropagation();
                this.removeNote();
              },
              group: 3
            }
          ]
        : [
            {
              key: "note-add",
              label: "Add Note",
              onClick: (e: any) => {
                e?.domEvent?.stopPropagation();
                this.openNoteModal();
              },
              group: 3
            }
          ]),

      {
        key: "enabled-toggle",
        label: this.props.action.enabled === false ? "Enable action" : "Disable action",
        // Explicit id: the auto-generated one is derived from the label, which flips
        // between "Disable action" and "Enable action" with the toggle state.
        dataTestId: "actionEnabledToggleMenuItem",
        onClick: (e: any) => this.toggleActionEnabled(e),
        group: 3
      },

      {
        key: "15",
        label: "Remove",
        onClick: (e: any) => this.removeSelectedItem(e),
        danger: true,
        group: 3
      }
    ];

    if (this.props.preventActionRemoval) {
      const removeIndex = actionMenu.findIndex((item) => item.key === "15" || item.label === "Remove");
      if (removeIndex !== -1) {
        actionMenu.splice(removeIndex, 1);
      }
    }

    if (this.props.preventActionPaste) {
      const pasteIndex = actionMenu.findIndex((item) => item.key === "12" || item.label === "Paste");
      if (pasteIndex !== -1) {
        actionMenu.splice(pasteIndex, 1);
      }
    }

    const uniquekey: string = this.state.uniqueKey.toString();
    const hasAccessEditAction = KMainFunctions.hasUserAccessInWorkspaceByProjectRole(
      EUserAccessPart.EditComponentAction,
      this.props.sd.project?.projectAccess
    );
    const hasAccessEditSystemAction = KMainFunctions.hasUserAccessInWorkspaceByProjectRole(
      EUserAccessPart.AddEditSystemActions,
      this.props.sd.project?.projectAccess
    );
    const isActionSystem = this.props.actionDefinition?.actionType === EDatasourceType.SystemJSFunctions;
    const isActionDisabled: boolean = this.props.action.enabled === false;

    // Names the datasource in front while another datasource holds the same action name (KOA-18147).
    // Display only: the onboarding id below and every name comparison keep the bare name.
    const actionNameDisplay: string = formatQualifiedName(
      this.getActionName(true),
      getActionDatasourceQualifier(this.props.actionDefinition, this.props.sd.actionDefinitions)
    );

    return (
      <div>
        <KuikaCollapsePanel
          onChange={this.changeCollapse}
          destroyInactivePanel={false}
          defaultActiveKey={this.getActiveKey()}
          activeKey={this.getActiveKey()}
          iconPlacement="right"
          className="kuika-right-panel__collapse kuika-right-panel__collapse--boxed kuika-right-panel__collapse--action"
          style={{
            pointerEvents: isActionSystem
              ? hasAccessEditSystemAction
                ? "auto"
                : "none"
              : hasAccessEditAction
                ? "auto"
                : "none"
            // Margin is a class now (action-card.scss), so the design column can read
            // --column-inset-start/-end instead of a fixed inline value.
          }}
          items={[
            {
              key: "1",
              label: (
                <div
                  id={`collapse_${uniquekey}`}
                  className={classNames(OVERFLOW_REVEAL_HOST_CLASS, {
                    "kuika-action-card--menu-open": this.state.visibleActionMenu
                  })}
                  data-testid="actionCollapseHeader"
                  data-onboarding-id={`right-panel_action_collapse_${actionDefinition?.name}`}
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}
                >
                  <div className="kuika-action-card__lead">
                    {/* The visible, dedicated drag target — react-beautiful-dnd's dragHandleProps
                        moved here from the whole header row above (see getDragDropProps). Named,
                        not aria-hidden: dragHandleProps sets role="button" + tabIndex, and an
                        aria-hidden focusable control is an a11y violation — the icon inside is
                        the one that's decorative. */}
                    <span className="kuika-action-card__grip" aria-label="Reorder action" {...this.getDragDropProps()}>
                      <KuikaSvg name="grip-vertical" type="common" width={14} height={14} aria-hidden="true" />
                    </span>
                    <div
                      className="kuika-action-card__text"
                      data-action-disabled={isActionDisabled ? "true" : undefined}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: 6, overflow: "hidden", minWidth: 0 }}>
                        <KuikaTextMedium
                          className="kuika-action-card__title"
                          title={actionNameDisplay}
                          data-testid="actionName"
                          data-onboarding-id={`right-panel_action_${this.getActionName(true)}`}
                        >
                          <KuikaOverflowText>{actionNameDisplay}</KuikaOverflowText>
                        </KuikaTextMedium>
                        {isActionDisabled && (
                          <KuikaBadge
                            className="kuika-action-card__disabled-badge"
                            dataTestId="actionDisabledBadge"
                            content="Disabled"
                            type="label"
                            color="grey"
                            variant="subtle"
                            size="small"
                          />
                        )}
                        {this.props.action.note && (
                          <KuikaPopover
                            visible={this.state.notePopoverVisible}
                            onVisibleChange={(visible) => this.setState({ notePopoverVisible: visible })}
                            title="Action Note"
                            position="bottom"
                            onClick={(e: React.MouseEvent): void => e.stopPropagation()}
                            onPointerDown={(e: React.PointerEvent): void => e.stopPropagation()}
                            content={
                              <div
                                style={{ width: 360, padding: "var(--gap-m) var(--gap-l) var(--gap-l)" }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  style={{
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    fontSize: 12,
                                    lineHeight: "20px",
                                    color: "var(--dark-8)",
                                    maxHeight: 280,
                                    overflowY: "auto",
                                    padding: "var(--gap-s) var(--gap-m)",
                                    backgroundColor: "var(--dark-1)",
                                    borderRadius: "var(--radius-l)",
                                    border: "1px solid var(--dark-2)"
                                  }}
                                >
                                  {this.props.action.note}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: 8,
                                    justifyContent: "flex-end",
                                    marginTop: "var(--gap-m)",
                                    paddingTop: "var(--gap-s)",
                                    borderTop: "1px solid var(--dark-2)"
                                  }}
                                >
                                  <KuikaButton
                                    type="secondary"
                                    size="sm"
                                    onClick={(e?: React.MouseEvent): void => {
                                      e?.stopPropagation();
                                      this.openNoteModal();
                                    }}
                                    uppercase
                                  >
                                    Edit
                                  </KuikaButton>
                                  <KuikaButton
                                    type="tertiary"
                                    size="sm"
                                    color="danger"
                                    onClick={(e?: React.MouseEvent): void => {
                                      e?.stopPropagation();
                                      this.removeNote();
                                    }}
                                    uppercase
                                  >
                                    Remove
                                  </KuikaButton>
                                </div>
                              </div>
                            }
                          >
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({ notePopoverVisible: !this.state.notePopoverVisible });
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                flexShrink: 0
                              }}
                              title="This action has a note"
                            >
                              <KuikaSvg name="file-text" type="common" width={14} height={14} color="var(--yellow-5)" />
                            </div>
                          </KuikaPopover>
                        )}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, overflow: "hidden", minWidth: 0 }}>
                        {this.getActionReturnInfo()}
                        {this.getActionTagInfo()}
                      </div>
                      {(this.getActionName(false) === "ChangeVisibilityOf" ||
                        this.getActionName(false) === "ToggleVisibilityOf" ||
                        this.getActionName(false) === "ChangeEnabledOf" ||
                        this.getActionName(false) === "SetValueOf" ||
                        this.getActionName(false) === "SetFocusTo" ||
                        this.getActionName(false) === "OpenCollapsePanelOf" ||
                        this.getActionName(false) === "CloseCollapsePanelOf" ||
                        this.getActionName(false) === "ToggleCollapsePanelOf") &&
                        this.getSelectedComponentToChangeName(allDi, allMasterDi) && (
                          <KuikaSmallText style={{ display: "block", minWidth: 0 }}>
                            <KuikaOverflowText>{`(${this.getSelectedComponentToChangeName(
                              allDi,
                              allMasterDi
                            )})`}</KuikaOverflowText>
                          </KuikaSmallText>
                        )}
                    </div>
                  </div>
                  <div
                    className="kuika-action-card__menu"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <KuikaDropdownMenu
                      setOpen={this.handleActionMenuVisibleChange}
                      open={this.state.visibleActionMenu}
                      options={actionMenu}
                      trigger="click"
                    >
                      <KuikaButton
                        type="tertiary"
                        size="sm"
                        isIcon
                        color="neutral"
                        data-testid="actionMenuThreedotButton"
                      >
                        <KuikaSvg name="dots-vertical" type="styling-panel-icons" width={14} height={14} />
                      </KuikaButton>
                    </KuikaDropdownMenu>
                  </div>
                </div>
              ),
              children: (
                <div className="kuika-right-panel__collapse-body" data-testid="actionCollapseContent">
                  {this.props.actionPanelStatus === EActionPanelStatus.new && (
                    <KuikaSmallMediumText style={{ marginBottom: "8px" }}>
                      New {this.props.eventName} Action
                    </KuikaSmallMediumText>
                  )}
                  {this.getParameterList()}

                  {isOptionalParameterMenuOffered(this.props.action.label) && (
                    <OptionalParameterList
                      action={this.props.action}
                      onOptionalParameterSave={this.onOptionalParameterSave}
                    />
                  )}

                  {(this.state.confirmationVisible === true ||
                    (this.props.action.confirmationMessage && this.props.action.confirmationMessage.length > 0)) && (
                    <ActionConfirmation
                      key={`actionConfirmation_${this.props.action.id}`}
                      confirmationMessage={this.props.action.confirmationMessage}
                      confirmationFontFamily={this.props.action.confirmationFontFamily}
                      confirmationHeader={this.props.action.confirmationHeader}
                      confirmationIcon={this.props.action.confirmationIcon}
                      confirmationIconBackgroundColor={this.props.action.confirmationIconBackgroundColor}
                      confirmationConfirmButtonColor={this.props.action.confirmationConfirmButtonColor}
                      confirmationCancelButtonColor={this.props.action.confirmationCancelButtonColor}
                      onChange={this.handleActionConfirmation}
                    />
                  )}
                  {(this.state.recurringVisible === true || this.props.action.isRecurring) && (
                    <RecurringActionInput
                      key={`recurringActionInput_${this.props.action.id}`}
                      recurringInterval={this.props.action.recurringInterval}
                      onChange={this.handleRecurringInterval}
                    />
                  )}
                  <ActionCondition
                    action={this.props.action}
                    key={`actionCondition_${this.props.action.id}`}
                    condition={this.props.action.condition}
                    onChange={this.handleActionCondition}
                  />

                  {this.props.action.label === "ForEach" && (
                    <ForEachActionSymbolGroup
                      key={`forEachActionSymbolGroup_${this.props.action.id}`}
                      action={this.props.action}
                      forEachData={this.props.action.forEachData}
                      updateForEachData={this.updateForEachData}
                      getActionDefinitionItems={this.props.getActionDefinitionItems}
                    />
                  )}

                  {this.props.action.label === "IfThenElse" && (
                    <IfThenElseSymbolGroup
                      key={`ifThenElseSymbolGroup_${this.props.action.id}`}
                      ifThenElseData={this.props.action.ifThenElseData}
                      updateIfThenElseData={this.updateIfThenElseData}
                      getActionDefinitionItems={this.props.getActionDefinitionItems}
                    />
                  )}

                  {this.props.actionDefinition?.actionCategory !== EActionCategory.Bag &&
                    this.props.actionDefinition?.actionCategory !== EActionCategory.Cache &&
                    this.props.actionDefinition?.isTagDisabled !== true &&
                    this.props.action.tag !== null &&
                    this.props.action.tag !== undefined && (
                      <div key={`tag-input-${this.props.action.id}`}>
                        <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                          <span
                            style={{ marginBottom: 6, marginTop: 8 }}
                            className="k_Regular-G1-Left kuika_rightPanelDIName"
                          >
                            Tag
                          </span>
                        </span>
                        <KuikaInput
                          ref={this.tagInputRef}
                          data-testid="actionTagInput"
                          style={{ width: "100%", margin: "3px" }}
                          size="sm"
                          defaultValue={this.props.action.tag}
                          onKeyDown={(e) => {
                            if (!e.key.match(/^[a-zA-Z0-9_]*$/)) {
                              e.preventDefault();
                            }
                          }}
                          onBlur={(e) => {
                            this.updateActionTag(e.target.value);
                          }}
                        />
                      </div>
                    )}

                  {this.getSqlLikeSettings(this.props.action)}

                  {this.props.actionDefinition?.name === "GetAuditLogs" && (
                    <div
                      className={classNames("kuika_switch_property", OVERFLOW_REVEAL_HOST_CLASS)}
                      style={SWITCH_PROPERTY_ROW_STYLE}
                    >
                      <KuikaTextMedium style={SWITCH_PROPERTY_LABEL_STYLE}>
                        <KuikaOverflowText>Show this project's logs</KuikaOverflowText>
                      </KuikaTextMedium>
                      <div style={{ flexShrink: 0 }}>
                        <KuikaSwitch
                          onChange={(checked) => {
                            const param = this.props.action.parameters?.find((p) => p.name === "onlyCurrentProject");
                            if (param) {
                              this.updateActionParameter(param, {
                                category: ESymbolCategory.fixed,
                                fixedValue: checked,
                                label: "fixed",
                                description: ""
                              } as ISymbol);
                            }
                          }}
                          checked={(() => {
                            const v = this.props.action.parameters?.find((p) => p.name === "onlyCurrentProject")?.symbol
                              ?.fixedValue;
                            return v === true || v === "true";
                          })()}
                        />
                      </div>
                    </div>
                  )}

                  {actionDefinition?.hideDontTriggerValidationButton !== true &&
                    this.props.sd.dashboardState !== DashboardState.scheduledJobs && (
                      <div
                        className={classNames(
                          "kuika_switch_property",
                          "kuika_dont-trigger-validations",
                          OVERFLOW_REVEAL_HOST_CLASS
                        )}
                        style={SWITCH_PROPERTY_ROW_STYLE}
                      >
                        <KuikaTextMedium style={SWITCH_PROPERTY_LABEL_STYLE}>
                          <KuikaOverflowText>Don't trigger validations</KuikaOverflowText>
                        </KuikaTextMedium>
                        <div style={{ flexShrink: 0 }}>
                          <KuikaSwitch
                            onChange={this.handleDontTriggerValidations}
                            checked={this.props.action.dontTriggerValidations}
                          />
                        </div>
                      </div>
                    )}

                  {this.props.actionDefinition?.actionType === EDatasourceType.JavaScriptAction && (
                    <div
                      className={classNames("kuika_switch_property", OVERFLOW_REVEAL_HOST_CLASS)}
                      style={SWITCH_PROPERTY_ROW_STYLE}
                    >
                      <KuikaTextMedium style={SWITCH_PROPERTY_LABEL_STYLE}>
                        <KuikaOverflowText>Run on Server</KuikaOverflowText>
                      </KuikaTextMedium>
                      <div style={{ flexShrink: 0 }}>
                        <KuikaSwitch
                          onChange={(checked) => {
                            const param = this.props.action.parameters?.find((p) => p.name === "runOnServer");
                            if (param) {
                              this.updateActionParameter(param, {
                                category: ESymbolCategory.fixed,
                                fixedValue: checked,
                                label: "fixed",
                                description: ""
                              } as ISymbol);
                            }
                          }}
                          checked={(() => {
                            const v = this.props.action.parameters?.find((p) => p.name === "runOnServer")?.symbol
                              ?.fixedValue;
                            return v === true || v === "true";
                          })()}
                        />
                      </div>
                    </div>
                  )}

                  {this.props.actionDefinition?.isServerSideAction === true && (
                    <div
                      className={classNames(
                        "kuika_switch_property",
                        "kuika_is-audit-enabled",
                        OVERFLOW_REVEAL_HOST_CLASS
                      )}
                      style={SWITCH_PROPERTY_ROW_STYLE}
                    >
                      <KuikaTextMedium style={SWITCH_PROPERTY_LABEL_STYLE}>
                        <KuikaOverflowText>Enable Audit Logs</KuikaOverflowText>
                      </KuikaTextMedium>
                      <div style={{ flexShrink: 0 }}>
                        <KuikaSwitch
                          onChange={this.handleIsAuditEnabled}
                          checked={this.props.action.isAuditEnabled ?? false}
                        />
                      </div>
                    </div>
                  )}

                  {this.props.actionDefinition?.isServerSideAction === true && this.props.action.isAuditEnabled && (
                    <div style={{ display: "flex" }}>
                      <KuikaTextMedium style={{ display: "block", marginBottom: 6, flex: 2 }}>
                        Audit Level
                      </KuikaTextMedium>
                      <KuikaSelectbox
                        size="sm"
                        style={{ width: "100%", flex: 2 }}
                        value={this.props.action.auditLevel ?? "Metadata"}
                        onChange={this.handleAuditLevelChange}
                        options={[
                          { label: "Metadata", value: "Metadata" },
                          { label: "Full", value: "Full" }
                        ]}
                      />
                    </div>
                  )}

                  <div className="kuika_styling_typography_footer" style={{ padding: "4px 6px", display: "flow-root" }}>
                    <div style={{ float: "left" }}>
                      {this.props.actionDefinition &&
                        (this.props.actionDefinition.actionType === EDatasourceType.SystemCSFunctions ||
                          this.props.actionDefinition.actionType === EDatasourceType.SystemJSFunctions ||
                          (this.props.actionDefinition.actionType === EDatasourceType.ManagedDb &&
                            (this.props.actionDefinition.name === "SaveRecord" ||
                              this.props.actionDefinition.name === "DeleteRecord"))) &&
                        this.getActionHelpLink(this.props.actionDefinition)}
                    </div>
                    <KuikaButton
                      style={{ float: "right" }}
                      type="text"
                      size="sm"
                      uppercase
                      onClick={this.changeCollapse}
                    >
                      <KuikaSmallMediumText>Close</KuikaSmallMediumText>
                    </KuikaButton>
                  </div>
                </div>
              )
            }
          ]}
        />

        <KModal
          showModal={this.state.noteModalVisible}
          closeModal={this.closeNoteModal}
          header="Action Note"
          width={460}
          centered
          footer={
            <KModalFooter
              onCancel={this.closeNoteModal}
              submitLabel="Save"
              onSubmit={this.saveNote}
              status={this.state.noteSaveStatus}
            />
          }
        >
          <div className="kuika-action-note">
            <div className="kuika-action-note__header">
              <KuikaModalIconWrapper iconName="file-text" intent={this.getNoteModalIntent()} />
              <KuikaH5 className="kuika-action-note__title">Action Note</KuikaH5>
            </div>
            <KuikaInput
              ref={this.noteInputRef}
              type="textarea"
              rows={6}
              placeholder="Enter a note for this action..."
              defaultValue={this.props.action.note ?? ""}
              maxLength={2000}
              resizable={false}
              style={{ width: "100%" }}
            />
            <KuikaSmallText className="kuika-action-note__hint">Max 2000 characters</KuikaSmallText>
          </div>
        </KModal>

        <ConfigBraveSearchSettings
          editingBraveSearchId={this.state.mcpConfigModalVisibility?.braveSearchSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("braveSearchSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.braveSearchSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigDropboxSettings
          editingDropboxId={this.state.mcpConfigModalVisibility?.dropboxSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("dropboxSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.dropboxSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigSlackSettings
          editingSlackId={this.state.mcpConfigModalVisibility?.slackSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("slackSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.slackSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGithubSettings
          editingGithubId={this.state.mcpConfigModalVisibility?.githubSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("githubSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.githubSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGoogleMcpSettings
          editingGoogleMcpId={this.state.mcpConfigModalVisibility?.googleMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("googleMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.googleMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigGoogleMapMcpSettings
          editingGoogleMcpMapId={this.state.mcpConfigModalVisibility?.googleMapMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("googleMapMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.googleMapMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigJiraMcpSettings
          editingJiraMcpId={this.state.mcpConfigModalVisibility?.jiraMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("jiraMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.jiraMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigYoutubeMcpSettings
          editingYoutubeMcpId={this.state.mcpConfigModalVisibility?.youtubeMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("youtubeMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.youtubeMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigTrelloMcpSettings
          editingTrelloMcpId={this.state.mcpConfigModalVisibility?.trelloMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("trelloMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.trelloMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigOffice365McpSettings
          editingOffice365McpId={this.state.mcpConfigModalVisibility?.office365McpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("office365McpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.office365McpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigFirecrawlMcpSettings
          editingFirecrawlMcpId={this.state.mcpConfigModalVisibility?.firecrawlMcpSettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("firecrawlMcpSettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.firecrawlMcpSettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />

        <ConfigApifySettings
          editingApifyId={this.state.mcpConfigModalVisibility?.apifySettings?.editingId}
          formInputName={[]}
          closeModal={() => {
            this.updateMcpModalVisibility("apifySettings", false);
          }}
          showModal={this.state.mcpConfigModalVisibility?.apifySettings?.visibility ?? false}
          commonSettings={this.props.sd.commonSettings}
          getSectionDescription={function (contentKey: string): React.ReactNode {
            return <></>;
          }}
          handleCreateCommonConfig={this.createCommonConfig}
          handleUpdateCommonConfig={this.updateCommonConfig}
          handleDeleteCommonConfig={this.deleteCommonConfig}
        />
      </div>
    );
  }

  copySelectedItem(e: any): boolean {
    e?.domEvent?.stopPropagation();
    if (this.props.eventName === undefined) {
      return false;
    }
    const obj = buildDesignerActionClipboard(
      getSdInstance(),
      this.props.action,
      this.props.eventName,
      this.props.sd.sdId
    );

    this.props.context.setClipboardValue("action", obj);
    if (this.props.setClipboardValue) this.props.setClipboardValue("action");
    this.setState({ visibleActionMenu: false });
    return true;
  }

  // Moving an action otherwise costs two menu operations (Copy, then Remove).
  // The clipboard holds a deep clone, so removing the source afterwards is safe.
  cutSelectedItem(e: any): void {
    const copied: boolean = this.copySelectedItem(e);
    if (!copied) {
      return;
    }
    this.removeSelectedItem(e);
  }

  pasteSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    const clipboardValue = this.props.context.getClipboardValue("action") as IActionClipboard | undefined;
    if (!clipboardValue || !clipboardValue.action) return;
    const result = pasteDesignerActionClipboard(getSdInstance(), this.props.action, clipboardValue, this.props.sd.sdId);
    this.triggerOnActionSaved(result.action, ESdChangeReason.DiActionUpdated);
    if (result.screenDesignChanged) {
      this.props.sd.setScreenDesign(result.screenDesign, ESdChangeReason.DiActionUpdated);
    }

    this.setState({ visibleActionMenu: false });
  }

  addConfirmationSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.setState({ confirmationVisible: true, visibleActionMenu: false }, () => {
      this.triggerOnActionSaved(
        addDesignerActionConfirmation(this.props.action),
        ESdChangeReason.ConfirmationMessageChanged
      );
      if (this.isExpandedPanel === false) {
        this.onExpand(() => {
          const el = document.querySelector(`[data-rbd-drag-handle-draggable-id="draggable_${this.props.action?.id}"]`);
          this.setFocusToConfirmationInput(el);
        });
      }
    });
  }

  removeConfirmationSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.setState({ confirmationVisible: false, visibleActionMenu: false }, () => {
      this.triggerOnActionSaved(
        removeDesignerActionConfirmation(this.props.action),
        ESdChangeReason.ConfirmationMessageChanged
      );
    });
  }

  addRecurringSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.setState({ recurringVisible: true, visibleActionMenu: false }, () => {
      this.triggerOnActionSaved(addDesignerActionRecurring(this.props.action), ESdChangeReason.RecurringIntervalChange);
      if (this.isExpandedPanel === false) {
        this.onExpand(() => {
          const el = document.querySelector(`[data-rbd-drag-handle-draggable-id="draggable_${this.props.action?.id}"]`);
          this.setFocusToRecurringInput(el);
        });
      }
    });
  }

  removeRecurringSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.setState({ recurringVisible: false, visibleActionMenu: false }, () => {
      this.triggerOnActionSaved(
        removeDesignerActionRecurring(this.props.action),
        ESdChangeReason.RecurringIntervalChange
      );
    });
  }

  addConditionSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.triggerOnActionSaved(addDesignerActionBlankCondition(this.props.action));
    if (this.isExpandedPanel === false) {
      this.onExpand(() => {
        const el = document.querySelector(`[data-rbd-drag-handle-draggable-id="draggable_${this.props.action?.id}"]`);
        this.setFocusToCondition(el);
      });
    }
    this.setState({ visibleActionMenu: false });
  }

  removeConditionSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    this.triggerOnActionSaved(removeDesignerActionCondition(this.props.action));
    this.setState({ visibleActionMenu: false });
  }

  removeSelectedItem(e: any): void {
    e?.domEvent?.stopPropagation();
    const sJob = this.props.sd.getSelectedSj();
    const apiMethod = this.props.sd.getSelectedApiMethod();
    const wf = this.props.sd.selectedWf;
    const bleMethod = this.props.sd.getSelectedBluetoothMethod();

    if (this.props.sd.isDocumentParameterAuthoringActive()) {
      // The tool is its own host — no selected sub-entity to guard on (KOA-17254).
      this.props.sd.deleteDocumentParameterAction(this.props.action);
    } else if (sJob && this.props.sd.dashboardState === DashboardState.scheduledJobs) {
      this.props.sd.deleteScheduleJobAction(this.props.action, sJob);
    } else if (apiMethod && this.props.sd.dashboardState === DashboardState.apiManagement) {
      this.props.sd.deleteActionOfApiMethod(this.props.action);
    } else if (wf && this.props.sd.dashboardState === DashboardState.workFlow) {
      this.props.sd.deleteActionFromWorkflowStep(this.props.action, ESdChangeReason.WFStepMappingChange);
    } else if (bleMethod && this.props.sd.dashboardState === DashboardState.dataDiagramScheme) {
      this.props.sd.deleteActionOfBluetoothMethod(this.props.action);
    } else {
      if (this.props.action.label === "NAVIGATE" || this.props.action.label === "NavigateToTask") {
        const existingNavKuikaIdParameter = this.props.action.parameters?.find(
          (x) =>
            x.name === "navigationKuikaId" &&
            x.symbol &&
            x.symbol.fixedValue !== undefined &&
            x.symbol.fixedValue !== ""
        );
        if (existingNavKuikaIdParameter !== undefined) {
          const selectedDisplayItem = this.props.sd.selectedKuikaIds?.[0];
          this.props.sd.deleteItemByKuikaId(existingNavKuikaIdParameter.symbol.fixedValue, selectedDisplayItem);
        }
      }
      this.props.deleteAction(this.props.action);
    }
    this.setState({ visibleActionMenu: false });
  }

  updateActionTag = (value?: string | null) => {
    this.triggerOnActionSaved(
      setDesignerActionTag(this.props.action, value),
      ESdChangeReason.ActionParameterFixedValueChanged
    );
    this.setState({ visibleActionMenu: false });
  };

  updateActionNote = (value?: string | null) => {
    this.triggerOnActionSaved(
      setDesignerActionNote(this.props.action, value),
      ESdChangeReason.ActionParameterFixedValueChanged
    );
  };

  openNoteModal = () => {
    this.setState({ noteModalVisible: true, notePopoverVisible: false, visibleActionMenu: false });
  };

  closeNoteModal = () => {
    this.setState({ noteModalVisible: false });
  };

  getNoteModalIntent = (): KuikaModalIconIntent => (this.props.action.note ? "edit" : "create");

  // The note lands on the card's header as its note mark; the dialog holds SAVE's ✓ before it leaves.
  saveNote = (): void => {
    // Live again once the ✓ replaces the spinner, so a second press would save behind the closing dialog.
    if (!this.noteSaveStatus.canStart) return;
    this.noteSaveStatus.start();
    const value: string | null = this.noteInputRef.current?.value?.trim() || null;
    this.updateActionNote(value);
    this.noteSaveStatus.succeed(this.closeNoteModal);
  };

  removeNote = () => {
    this.updateActionNote(null);
    this.setState({ notePopoverVisible: false, visibleActionMenu: false });
  };

  checkNeedRender = (
    changeReason: ESdChangeReason,
    nextProps: IActionPanelProps & IWithSDProps & IWithContextProp
  ): boolean => {
    return (
      !isEqual(this.props.action, nextProps.action) || !isEqual(this.props.actionDefinition, nextProps.actionDefinition)
    );
  };
}

const actionPanel = withContext<IActionPanelProps>(withSD<IActionPanelProps>(ActionPanel));
export { actionPanel as ActionPanel };
